var _defs, _defs2, _defs3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg102593404401278(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M481.72,245.83c0,9.61-1.05,19.18-3.33,28.48c-0.75,3.06-1.65,6.11-2.68,9.11 c-0.3,0.86-0.6,1.72-0.92,2.57c-0.26,0.7-0.53,1.4-0.8,2.09c-0.08,0.19-0.15,0.38-0.23,0.57c-0.29,0.72-0.58,1.44-0.89,2.15 c-0.05,0.11-0.1,0.23-0.15,0.35c-0.3,0.7-0.61,1.4-0.92,2.09c-0.14,0.31-0.28,0.61-0.42,0.91c-0.28,0.62-0.57,1.23-0.87,1.84 c-0.31,0.65-0.63,1.29-0.95,1.93c-0.12,0.23-0.23,0.46-0.35,0.68c-0.28,0.55-0.57,1.1-0.85,1.65c-0.23,0.43-0.46,0.85-0.69,1.27 c-1.06,1.96-2.17,3.89-3.33,5.8c-0.47,0.78-0.95,1.56-1.44,2.33c-0.11,0.19-0.23,0.38-0.35,0.57c-0.56,0.88-1.13,1.76-1.71,2.64 c-0.47,0.71-0.94,1.42-1.43,2.13c-0.42,0.62-0.84,1.23-1.27,1.85c-0.09,0.13-0.18,0.26-0.28,0.39c-0.44,0.64-0.9,1.28-1.35,1.92 c-0.56,0.79-1.13,1.56-1.7,2.34c-0.12,0.16-0.23,0.32-0.35,0.47c-0.65,0.89-1.32,1.77-1.98,2.64c-0.4,0.52-0.8,1.05-1.21,1.56 c-0.72,0.95-1.46,1.89-2.21,2.83c-0.71,0.9-1.43,1.79-2.16,2.68c-0.08,0.1-0.16,0.19-0.24,0.29c-0.72,0.89-1.44,1.77-2.18,2.65 c-0.21,0.27-0.44,0.54-0.66,0.8c-0.67,0.81-1.35,1.62-2.03,2.42c-1.96,2.32-3.94,4.62-5.93,6.9c-4.05,4.66-8.19,9.29-12.41,13.89 c-3.51,3.8-7.07,7.58-10.7,11.29c-17.42,17.89-36.28,34.58-56.79,47.88c-2.55,1.65-5.12,3.26-7.72,4.79 c-0.95,0.56-1.9,1.12-2.85,1.67c-0.16,0.09-0.33,0.19-0.49,0.28c-0.98,0.56-1.96,1.11-2.95,1.65c-1.01,0.56-2.02,1.11-3.04,1.64 c-0.46,0.24-0.92,0.48-1.38,0.72c-1.99,1.04-4,2.04-6.03,3c-1.09,0.52-2.18,1.02-3.28,1.51c-1.01,0.46-2.03,0.91-3.05,1.35 c-0.42,0.18-0.83,0.36-1.25,0.53c-0.93,0.4-1.87,0.78-2.81,1.16c-1.81,0.73-3.64,1.43-5.48,2.09c-0.7,0.26-1.41,0.51-2.12,0.76 c-0.4,0.14-0.8,0.27-1.2,0.41c-0.66,0.22-1.32,0.44-1.98,0.65c-0.57,0.19-1.15,0.37-1.72,0.55c-0.02,0.01-0.04,0.01-0.06,0.02 c-1.13,0.35-2.26,0.69-3.39,1.02c-1.79,0.52-3.58,1-5.38,1.46c-1.19,0.3-2.38,0.58-3.58,0.85c-1.13,0.26-2.26,0.5-3.4,0.74 c-0.09,0.02-0.18,0.04-0.27,0.05c-1.18,0.24-2.37,0.47-3.56,0.68c-0.61,0.11-1.21,0.21-1.82,0.31c-0.61,0.1-1.22,0.2-1.84,0.29 c-0.55,0.09-1.11,0.17-1.66,0.24c-0.67,0.1-1.35,0.19-2.02,0.28c-7.11,0.91-14.24,1.29-21.37,1.21c-0.43,0-0.85-0.01-1.28-0.02 c-6.46-0.12-12.92-0.62-19.35-1.45c-0.47-0.06-0.94-0.12-1.41-0.19c-0.81-0.11-1.62-0.22-2.43-0.34c-0.63-0.1-1.26-0.2-1.89-0.3 c-2.67-0.42-5.32-0.9-7.97-1.44c-0.59-0.11-1.17-0.23-1.75-0.36c-1.78-0.37-3.57-0.77-5.34-1.19c-1.19-0.28-2.37-0.57-3.55-0.87 c-0.59-0.15-1.18-0.3-1.77-0.46c-0.59-0.15-1.18-0.31-1.77-0.47c-2.35-0.63-4.69-1.31-7.02-2.02c-2.71-0.82-5.4-1.69-8.08-2.61 c-0.97-0.33-1.95-0.67-2.92-1.01c-3.01-1.07-6.02-2.2-8.99-3.37c-0.53-0.21-1.07-0.43-1.63-0.66c-0.43-0.18-0.86-0.37-1.31-0.57 c-0.29-0.13-0.58-0.26-0.88-0.4c-1.94-0.88-4.05-1.91-6.32-3.07c-0.38-0.2-0.77-0.4-1.16-0.6c-1.39-0.73-2.84-1.5-4.33-2.32 c-3.13-1.72-6.48-3.62-10-5.69c-40.01-23.54-101.26-67.72-115.64-84.47c-0.73-0.85-1.44-1.71-2.15-2.58 c-0.55-0.68-1.1-1.37-1.63-2.07c-0.49-0.63-0.97-1.26-1.44-1.91c-0.42-0.56-0.83-1.13-1.23-1.71c-0.38-0.53-0.76-1.07-1.13-1.61 c-0.02-0.04-0.05-0.08-0.08-0.12c-0.45-0.67-0.9-1.34-1.34-2.02c-0.42-0.65-0.84-1.3-1.24-1.96c-0.2-0.31-0.39-0.63-0.58-0.95 c-0.45-0.74-0.89-1.48-1.32-2.22c0-0.01,0-0.01-0.01-0.02c-0.46-0.82-0.92-1.64-1.37-2.47c-0.78-1.45-1.53-2.91-2.23-4.39 c-0.18-0.38-0.36-0.77-0.54-1.15c-1.42-3.04-2.67-6.14-3.74-9.29c-0.39-1.1-0.74-2.21-1.08-3.32c-0.43-1.43-0.82-2.87-1.18-4.31 c-0.07-0.29-0.14-0.57-0.2-0.86c-0.18-0.75-0.35-1.51-0.5-2.27c-0.23-1.06-0.42-2.12-0.6-3.19c-0.04-0.26-0.09-0.52-0.12-0.78 c-0.09-0.55-0.17-1.1-0.24-1.66c-0.09-0.66-0.17-1.33-0.24-1.99c-0.03-0.23-0.05-0.45-0.07-0.67c-0.06-0.57-0.1-1.14-0.15-1.7 c0-0.05,0-0.1-0.01-0.14c-0.05-0.68-0.09-1.35-0.11-2.02c-0.01-0.07-0.01-0.13-0.01-0.19c-0.03-0.71-0.05-1.42-0.06-2.13 c-0.005-0.265,0.003-0.529,0.002-0.793c-0.002-0.416-0.003-0.831,0.003-1.247c0.014-1.044,0.044-2.087,0.105-3.129 c0.04-0.68,0.09-1.36,0.15-2.03c0.12-1.34,0.28-2.68,0.48-4.01c0.1-0.68,0.21-1.36,0.34-2.03c0.24-1.35,0.53-2.7,0.87-4.05 c0.9-3.55,2.05-6.97,3.45-10.25c1.06-2.53,2.26-4.96,3.59-7.34c0.1-0.2,0.22-0.41,0.34-0.61c5.39-9.49,12.72-17.91,20.98-25.71 c0.88-0.84,1.77-1.66,2.68-2.47c0.95-0.87,1.91-1.72,2.88-2.58c0.06-0.05,0.12-0.11,0.18-0.16c1.55-1.36,3.12-2.7,4.71-4.03 c2.45-2.05,4.94-4.06,7.45-6.06c0.08-0.07,0.17-0.13,0.25-0.2c2.15-1.7,4.32-3.39,6.48-5.07c3.4-2.63,6.81-5.25,10.15-7.86 c0.89-0.69,1.77-1.38,2.64-2.07c0.97-0.76,1.92-1.52,2.87-2.28c8.96-7.18,16.68-14.82,23.86-22.64c1.39-1.52,2.77-3.05,4.14-4.59 c0.65-0.74,1.3-1.47,1.94-2.21c9.13-10.4,17.62-20.92,27.07-30.85c2.25-2.37,4.55-4.7,6.92-6.99c2-1.91,4.03-3.79,6.14-5.63 c2.41-2.12,4.89-4.19,7.49-6.19c3.55-2.76,7.29-5.41,11.29-7.94c0.98-0.63,1.95-1.24,2.93-1.84c99.71-61.97,173.1-41.74,222.06,0 c3.69,3.13,7.25,6.4,10.66,9.78c2.08,2.01,4.09,4.09,6.04,6.19c0.22,0.22,0.42,0.45,0.63,0.69c1.37,1.46,2.7,2.93,4,4.41 c0.39,0.44,0.77,0.88,1.15,1.32c0.57,0.66,1.14,1.32,1.7,1.99c0.69,0.81,1.37,1.63,2.05,2.45c0.43,0.52,0.85,1.04,1.27,1.56 c2.73,3.36,5.33,6.77,7.81,10.2c0.5,0.68,0.99,1.37,1.48,2.06c3.42,4.8,6.6,9.65,9.55,14.47c0.42,0.69,0.84,1.38,1.25,2.06 c0.42,0.69,0.83,1.38,1.23,2.07c0.4,0.68,0.8,1.37,1.19,2.05c0.4,0.69,0.79,1.37,1.17,2.05c0.38,0.68,0.76,1.37,1.14,2.05 c0.39,0.68,0.76,1.36,1.11,2.03c0.37,0.68,0.73,1.36,1.09,2.03c0.36,0.67,0.71,1.35,1.06,2.02c0.34,0.67,0.69,1.34,1.03,2 c0.34,0.67,0.67,1.34,1,2c1.31,2.64,2.55,5.25,3.73,7.82c0.58,1.3,1.16,2.59,1.71,3.86c2.49,5.72,4.62,11.19,6.36,16.28 c0.01,0.02,0.02,0.05,0.02,0.07c0.17,0.49,0.33,0.97,0.49,1.45c0.17,0.5,0.33,0.99,0.49,1.48c0.12,0.38,0.25,0.75,0.36,1.13 c0.18,0.56,0.36,1.12,0.53,1.69c0.19,0.61,0.37,1.22,0.54,1.83c0.33,1.12,0.65,2.24,0.95,3.37c0.26,0.95,0.51,1.9,0.75,2.86 c0.05,0.18,0.1,0.35,0.14,0.53c0.04,0.15,0.07,0.3,0.11,0.45c0.14,0.56,0.28,1.12,0.41,1.69c0.36,1.49,0.69,2.99,1,4.49 c0.17,0.82,0.34,1.63,0.49,2.45c0.03,0.15,0.06,0.3,0.09,0.46c0.15,0.77,0.29,1.54,0.42,2.31c0.18,1.03,0.35,2.07,0.5,3.1 c0.13,0.78,0.24,1.57,0.35,2.36c0.01,0.11,0.03,0.23,0.05,0.35c0.07,0.52,0.14,1.05,0.2,1.58c0.06,0.44,0.11,0.88,0.16,1.31 c0.18,1.59,0.34,3.17,0.47,4.76c0.03,0.36,0.06,0.72,0.09,1.08c0.04,0.6,0.08,1.21,0.12,1.81c0.04,0.67,0.08,1.34,0.11,2.02 c0.03,0.52,0.05,1.03,0.07,1.55c0.03,0.76,0.05,1.53,0.06,2.29C481.71,244.05,481.72,244.94,481.72,245.83z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M481.72,245.83c0,9.61-1.05,19.18-3.33,28.48c-0.75,3.06-1.65,6.11-2.68,9.11 c-0.3,0.86-0.6,1.72-0.92,2.57c-0.26,0.7-0.53,1.4-0.8,2.09c-0.08,0.19-0.15,0.38-0.23,0.57c-0.29,0.72-0.58,1.44-0.89,2.15 c-0.05,0.11-0.1,0.23-0.15,0.35c-0.3,0.7-0.61,1.4-0.92,2.09c-0.14,0.31-0.28,0.61-0.42,0.91c-0.28,0.62-0.57,1.23-0.87,1.84 c-0.31,0.65-0.63,1.29-0.95,1.93c-0.12,0.23-0.23,0.46-0.35,0.68c-0.28,0.55-0.57,1.1-0.85,1.65c-0.23,0.43-0.46,0.85-0.69,1.27 c-1.06,1.96-2.17,3.89-3.33,5.8c-0.47,0.78-0.95,1.56-1.44,2.33c-0.11,0.19-0.23,0.38-0.35,0.57c-0.56,0.88-1.13,1.76-1.71,2.64 c-0.47,0.71-0.94,1.42-1.43,2.13c-0.42,0.62-0.84,1.23-1.27,1.85c-0.09,0.13-0.18,0.26-0.28,0.39c-0.44,0.64-0.9,1.28-1.35,1.92 c-0.56,0.79-1.13,1.56-1.7,2.34c-0.12,0.16-0.23,0.32-0.35,0.47c-0.65,0.89-1.32,1.77-1.98,2.64c-0.4,0.52-0.8,1.05-1.21,1.56 c-0.72,0.95-1.46,1.89-2.21,2.83c-0.71,0.9-1.43,1.79-2.16,2.68c-0.08,0.1-0.16,0.19-0.24,0.29c-0.72,0.89-1.44,1.77-2.18,2.65 c-0.21,0.27-0.44,0.54-0.66,0.8c-0.67,0.81-1.35,1.62-2.03,2.42c-1.96,2.32-3.94,4.62-5.93,6.9c-4.05,4.66-8.19,9.29-12.41,13.89 c-3.51,3.8-7.07,7.58-10.7,11.29c-17.42,17.89-36.28,34.58-56.79,47.88c-2.55,1.65-5.12,3.26-7.72,4.79 c-0.95,0.56-1.9,1.12-2.85,1.67c-0.16,0.09-0.33,0.19-0.49,0.28c-0.98,0.56-1.96,1.11-2.95,1.65c-1.01,0.56-2.02,1.11-3.04,1.64 c-0.46,0.24-0.92,0.48-1.38,0.72c-1.99,1.04-4,2.04-6.03,3c-1.09,0.52-2.18,1.02-3.28,1.51c-1.01,0.46-2.03,0.91-3.05,1.35 c-0.42,0.18-0.83,0.36-1.25,0.53c-0.93,0.4-1.87,0.78-2.81,1.16c-1.81,0.73-3.64,1.43-5.48,2.09c-0.7,0.26-1.41,0.51-2.12,0.76 c-0.4,0.14-0.8,0.27-1.2,0.41c-0.66,0.22-1.32,0.44-1.98,0.65c-0.57,0.19-1.15,0.37-1.72,0.55c-0.02,0.01-0.04,0.01-0.06,0.02 c-1.13,0.35-2.26,0.69-3.39,1.02c-1.79,0.52-3.58,1-5.38,1.46c-1.19,0.3-2.38,0.58-3.58,0.85c-1.13,0.26-2.26,0.5-3.4,0.74 c-0.09,0.02-0.18,0.04-0.27,0.05c-1.18,0.24-2.37,0.47-3.56,0.68c-0.61,0.11-1.21,0.21-1.82,0.31c-0.61,0.1-1.22,0.2-1.84,0.29 c-0.55,0.09-1.11,0.17-1.66,0.24c-0.67,0.1-1.35,0.19-2.02,0.28c-7.11,0.91-14.24,1.29-21.37,1.21c-0.43,0-0.85-0.01-1.28-0.02 c-6.46-0.12-12.92-0.62-19.35-1.45c-0.47-0.06-0.94-0.12-1.41-0.19c-0.81-0.11-1.62-0.22-2.43-0.34c-0.63-0.1-1.26-0.2-1.89-0.3 c-2.67-0.42-5.32-0.9-7.97-1.44c-0.59-0.11-1.17-0.23-1.75-0.36c-1.78-0.37-3.57-0.77-5.34-1.19c-1.19-0.28-2.37-0.57-3.55-0.87 c-0.59-0.15-1.18-0.3-1.77-0.46c-0.59-0.15-1.18-0.31-1.77-0.47c-2.35-0.63-4.69-1.31-7.02-2.02c-2.71-0.82-5.4-1.69-8.08-2.61 c-0.97-0.33-1.95-0.67-2.92-1.01c-3.01-1.07-6.02-2.2-8.99-3.37c-0.53-0.21-1.07-0.43-1.63-0.66c-0.43-0.18-0.86-0.37-1.31-0.57 c-0.29-0.13-0.58-0.26-0.88-0.4c-1.94-0.88-4.05-1.91-6.32-3.07c-0.38-0.2-0.77-0.4-1.16-0.6c-1.39-0.73-2.84-1.5-4.33-2.32 c-3.13-1.72-6.48-3.62-10-5.69c-40.01-23.54-101.26-67.72-115.64-84.47c-0.73-0.85-1.44-1.71-2.15-2.58 c-0.55-0.68-1.1-1.37-1.63-2.07c-0.49-0.63-0.97-1.26-1.44-1.91c-0.42-0.56-0.83-1.13-1.23-1.71c-0.38-0.53-0.76-1.07-1.13-1.61 c-0.02-0.04-0.05-0.08-0.08-0.12c-0.45-0.67-0.9-1.34-1.34-2.02c-0.42-0.65-0.84-1.3-1.24-1.96c-0.2-0.31-0.39-0.63-0.58-0.95 c-0.45-0.74-0.89-1.48-1.32-2.22c0-0.01,0-0.01-0.01-0.02c-0.46-0.82-0.92-1.64-1.37-2.47c-0.78-1.45-1.53-2.91-2.23-4.39 c-0.18-0.38-0.36-0.77-0.54-1.15c-1.42-3.04-2.67-6.14-3.74-9.29c-0.39-1.1-0.74-2.21-1.08-3.32c-0.43-1.43-0.82-2.87-1.18-4.31 c-0.07-0.29-0.14-0.57-0.2-0.86c-0.18-0.75-0.35-1.51-0.5-2.27c-0.23-1.06-0.43-2.12-0.6-3.19c-0.04-0.26-0.09-0.52-0.12-0.78 c-0.09-0.55-0.17-1.1-0.24-1.66c-0.09-0.66-0.17-1.33-0.24-1.99c-0.03-0.23-0.05-0.45-0.07-0.67c-0.06-0.57-0.1-1.14-0.15-1.7 c0-0.05,0-0.1-0.01-0.14c-0.05-0.68-0.09-1.35-0.11-2.02c-0.01-0.07-0.01-0.13-0.01-0.19c-0.03-0.71-0.05-1.42-0.06-2.13 c-0.03-1.73,0.01-3.45,0.11-5.17c0.04-0.68,0.09-1.36,0.15-2.03c0.12-1.34,0.28-2.68,0.48-4.01c0.1-0.68,0.21-1.36,0.34-2.03 c0.24-1.35,0.53-2.7,0.87-4.05c0.9-3.55,2.05-6.97,3.45-10.25c1.06-2.53,2.26-4.96,3.59-7.34c0.1-0.2,0.22-0.41,0.34-0.61 c5.39-9.49,12.72-17.91,20.98-25.71c0.47-0.45,0.94-0.89,1.42-1.33c0.42-0.38,0.84-0.76,1.26-1.14c0.95-0.87,1.91-1.72,2.88-2.58 c0.06-0.05,0.12-0.11,0.18-0.16c1.55-1.36,3.12-2.7,4.71-4.03c2.45-2.05,4.94-4.06,7.45-6.06c0.08-0.07,0.17-0.13,0.25-0.2 c2.15-1.7,4.32-3.39,6.48-5.07c1.09-0.84,2.17-1.68,3.26-2.52c2.31-1.78,4.62-3.56,6.89-5.34c0.89-0.69,1.77-1.38,2.64-2.07 c0.97-0.76,1.92-1.52,2.87-2.28c8.96-7.18,16.68-14.82,23.86-22.64c1.39-1.52,2.77-3.05,4.14-4.59c0.65-0.74,1.3-1.47,1.94-2.21 c9.13-10.4,17.62-20.92,27.07-30.85c2.25-2.37,4.55-4.7,6.92-6.99c2-1.91,4.03-3.79,6.14-5.63c2.41-2.12,4.89-4.19,7.49-6.19 c3.55-2.76,7.29-5.41,11.29-7.94c0.98-0.63,1.95-1.24,2.93-1.84c99.71-61.97,173.1-41.74,222.06,0c3.69,3.13,7.25,6.4,10.66,9.78 c2.08,2.01,4.09,4.09,6.04,6.19c0.22,0.22,0.42,0.45,0.63,0.69c1.37,1.46,2.7,2.93,4,4.41c0.39,0.44,0.77,0.88,1.15,1.32 c0.57,0.66,1.14,1.32,1.7,1.99c0.69,0.81,1.37,1.63,2.05,2.45c0.43,0.52,0.85,1.04,1.27,1.56c2.73,3.36,5.33,6.77,7.81,10.2 c0.5,0.68,0.99,1.37,1.48,2.06c3.42,4.8,6.6,9.65,9.55,14.47c0.42,0.69,0.84,1.38,1.25,2.06c0.42,0.69,0.83,1.38,1.23,2.07 c0.4,0.68,0.8,1.37,1.19,2.05c0.4,0.69,0.79,1.37,1.17,2.05c0.38,0.68,0.76,1.37,1.14,2.05c0.39,0.68,0.76,1.36,1.11,2.03 c0.37,0.68,0.73,1.36,1.09,2.03c0.36,0.67,0.71,1.35,1.06,2.02c0.34,0.67,0.69,1.34,1.03,2c0.34,0.67,0.67,1.34,1,2 c1.32,2.64,2.56,5.25,3.73,7.82c0.58,1.3,1.16,2.59,1.71,3.86c2.49,5.72,4.62,11.19,6.36,16.28c0.01,0.02,0.02,0.05,0.02,0.07 c0.17,0.49,0.33,0.97,0.49,1.45c0.17,0.5,0.33,0.99,0.49,1.48c0.12,0.38,0.25,0.75,0.36,1.13c0.18,0.56,0.36,1.12,0.53,1.69 c0.19,0.61,0.37,1.22,0.54,1.83c0.33,1.12,0.65,2.24,0.95,3.37c0.26,0.95,0.51,1.9,0.75,2.86c0.05,0.18,0.1,0.35,0.14,0.53 c0.04,0.15,0.07,0.3,0.11,0.45c0.14,0.56,0.28,1.12,0.41,1.69c0.36,1.49,0.69,2.99,1,4.49c0.17,0.82,0.34,1.63,0.49,2.45 c0.03,0.15,0.06,0.3,0.09,0.46c0.15,0.77,0.29,1.54,0.42,2.31c0.18,1.03,0.35,2.07,0.5,3.1c0.13,0.78,0.24,1.57,0.35,2.36 c0.01,0.11,0.03,0.23,0.05,0.35c0.07,0.52,0.14,1.05,0.2,1.58c0.06,0.44,0.11,0.88,0.16,1.31c0.18,1.59,0.34,3.17,0.47,4.76 c0.03,0.36,0.06,0.72,0.09,1.08c0.04,0.6,0.08,1.21,0.12,1.81c0.04,0.67,0.08,1.34,0.11,2.02c0.03,0.52,0.05,1.03,0.07,1.55 c0.03,0.76,0.05,1.53,0.06,2.29C481.71,244.05,481.72,244.94,481.72,245.83z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#263238"
    },
    d: "M32.14,262.26C31.94,262.13,31.99,262.04,32.14,262.26L32.14,262.26z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M125.67,253.44c-1.02,6.8-6.04,12.33-12.57,14.47l-2.48,0.81c-8.92,12.63-24.56,18.02-37.89,10.19 l-3.9-2.29l-10.92-12.98c-0.04,0.01-0.09,0.02-0.13,0.03c-3.46,0.72-7.37,0.19-9.93-2.25c-0.41,2.14-3.2,3.4-5.07,2.3 c-1.87-1.1-2.11-4.16-0.44-5.55c-2.2,1.94-5.6,1.05-7.72-1.07c-0.09-5.79,0.52-11.58,1.95-17.29c0.9-3.55,2.05-6.97,3.45-10.25 c1.06-2.53,2.26-4.96,3.59-7.34c0.1-0.2,0.22-0.41,0.34-0.61c1.97-3.48,4.2-6.81,6.65-10.02c0.42-0.38,0.84-0.76,1.26-1.14 c0.95-0.87,1.91-1.72,2.88-2.58c0.06-0.05,0.12-0.11,0.18-0.16c1.55-1.36,3.12-2.7,4.71-4.03c2.45-2.05,4.94-4.06,7.45-6.06 c0.08-0.07,0.17-0.13,0.25-0.2c2.15-1.7,4.32-3.39,6.48-5.07c1.09-0.84,2.17-1.68,3.26-2.52c0.66,0.08,1.3,0.23,1.92,0.45 c2.67,0.93,3.13,3.38,4.98,5.06c2.46,2.25,4.82-1.53,8.61-1.41c11.65,0.36,7.13,12.31,12.82,10.81 c24.57-6.48,20.44,24.95,9.76,31.85C121.46,241.81,126.89,245.26,125.67,253.44z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    cx: 72.837,
    cy: 242.388,
    rx: 41.439,
    ry: 40.926
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#263238",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    cx: 72.837,
    cy: 240.732,
    rx: 37.784,
    ry: 37.316
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M32.236,255.442c-2.379,1.477-3.06,6.452-1.184,8.606c1.877,2.143,5.458,0.488,6.191-2.869 c0.346,0.94,1.451,1.092,2.02,0.282c0.401-0.58,0.418-1.485,0.138-2.104c-0.179-0.151-0.113-0.259,0,0 c1.217,0.967,3.316-0.087,3.608-2.155c-0.891,5.497,4.107,10.297,7.79,7.501c-1.087,2.336,0.337,5.41,2.242,6 c1.896,0.59,3.942-0.531,5.762-1.777c1.821-1.246,3.681-2.669,5.672-2.756c1.736-0.083,3.343,0.895,4.995,1.477 c5.26,1.831,11.416-0.595,15.44-6.11c2.659,4.55,9.21,2.875,10.966-2.791c0.369,2.652,2.185,4.672,4.209,4.698 c2.025,0.026,4.067-1.94,4.76-4.576l-0.001,0.035c0.045,2.51,2.283,3.739,3.884,2.124c2.045-2.059,3.312-5.842,2.306-8.872 c2.726-0.109,5.363-3.27,5.775-6.931c0.421-3.662-1.427-7.335-4.057-8.054c4.511-1.874,8.047-8.019,8.216-14.294 c0.16-6.262-3.057-12.087-7.489-13.552c-1.688-0.557-3.66-0.447-5.086,1.064c-0.525-3.569-2.147-6.758-4.533-8.361 c-3.803-2.569-9.093-0.809-11.923,3.973c1.38-2.47,1.473-6.042,0.217-8.385c-1.256-2.332-3.754-3.267-5.872-2.165 c-0.457-3.828-3.412-6.553-6.305-5.809c-2.883,0.744-5.219,4.835-4.972,8.711c-0.27-3.121-3.951-3.892-5.28-1.275 c0.114,0.236-0.056,0.096,0,0c-1.836-3.859-5.578-5.842-9.049-4.714c-3.691,1.21-6.791,5.846-7.264,10.901 c-2.546-2.322-6.261-2.222-8.995,0.25c-2.733,2.46-4.308,7.142-3.831,11.327c-2.872-2.835-7.704-1.288-9.673,3.094 c-1.969,4.382-0.612,10.586,2.715,12.42c-2.295,0.349-4.312,3.39-4.314,6.47c0.007,3.091,2.029,5.723,4.328,5.64 c-2.319,0.2-4.503,2.939-4.842,6.051C28.465,251.643,30.015,254.756,32.236,255.442z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M70.332,241.101c-1.158-0.971-2.635-1.442-4.048-0.997c-1.412,0.445-2.71,1.907-3.031,3.716 c-0.322,1.808,0.515,3.806,1.901,4.15c1.686,0.419,3.416-1.467,5.138-1.262c0.614,0.074,1.175,0.411,1.773,0.579 c2.466,0.694,4.964-1.524,7.059-3.608c0.737-0.733,1.491-1.489,1.993-2.493c0.502-1.003,0.705-2.321,0.268-3.288 c-0.609-1.348-2.107-1.46-3.362-1.201c-2.516,0.52-4.962,1.959-6.966,4.099c0.074-0.505,0.148-1.011,0.221-1.515 L70.332,241.101z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M106.451,236.175c-0.662-0.56-1.346-1.13-2.142-1.321c-0.795-0.191-1.74,0.085-2.261,0.942 c-0.714,1.174-0.307,2.918,0.557,3.76c0.864,0.842,2.028,1.02,3.137,1.172c1.139,0.156,2.581,0.12,3.17-1.202 c0.429-0.963,0.121-2.183-0.481-2.881c-0.602-0.698-1.426-0.997-2.223-1.277L106.451,236.175z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M49.907,215.743c-2.32,1.365-4.144,4.182-4.736,7.316c-0.179,0.946-0.177,2.121,0.456,2.579 c0.45,0.325,1.034,0.143,1.555-0.045c2.214-0.801,4.427-1.602,6.64-2.404c-1.063,0.582-2.152,1.184-3.011,2.196 c-0.859,1.012-1.452,2.536-1.202,3.916c0.294,1.62,1.685,2.542,3.012,2.437c1.327-0.105,2.576-1.021,3.672-2.073 c1.169-1.122,2.32-2.648,2.375-4.453c0.055-1.806-1.697-3.37-2.804-2.147c2.532-1.026,4.962-2.569,7.164-4.549 c0.797-0.717,1.583-1.517,2.096-2.572c0.513-1.055,0.707-2.42,0.271-3.446c-2.162-5.09-5.153,2.753-6.555,3.522 C56.182,217.475,53.282,213.757,49.907,215.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M39.235,238.689c-0.251,1.037-0.114,2.259,0.526,2.884c0.64,0.624,1.8,0.33,2.119-0.682 c-1.485,0.677-3.071,1.449-4.019,3.088c-0.948,1.639-0.771,4.392,0.685,4.914c0.909,0.326,1.897-0.308,2.754-0.949 c2.422-1.814,4.742-3.873,6.927-6.15c-0.69,1.969,0.847,4.061,2.485,4.139c1.639,0.079,3.195-1.147,4.623-2.324 c1.752-1.445,3.771-3.61,3.362-6.094c-0.355-2.162-2.531-2.996-4.229-2.251c-1.698,0.745-2.998,2.557-4.21,4.292 c0.957-1.777-0.311-4.25-1.927-4.431c-1.571-0.175-3.165,1.145-4.174,2.684c1.859-1.397,2.332-4.772-0.12-5.009 C42.442,232.645,39.653,236.965,39.235,238.689z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M89.765,228.085c-1.375-0.576-3.133,0.681-3.54,2.531c-0.407,1.85,0.631,3.87,2.089,4.066 c-1.078,0.184-2.121,0.932-2.832,2.031c-0.396,0.612-0.7,1.384-0.627,2.136c0.108,1.126,1.041,1.811,1.938,1.798 c0.897-0.014,1.761-0.551,2.587-1.076c-0.888,0.16-1.83,0.349-2.546,1.088c-0.716,0.739-1.048,2.231-0.431,2.992 c0.516,0.637,1.387,0.472,2.108,0.172c1.62-0.673,3.136-1.84,4.383-3.37c0.892,1.238,2.233,2.088,3.587,1.724 c1.354-0.363,2.533-2.265,2.141-3.897c-0.279-1.164-1.236-1.85-2.202-1.94c-0.965-0.09-1.942,0.308-2.877,0.748 c0.964-0.918,1.989-1.939,2.362-3.377c0.373-1.438-0.343-3.295-1.508-3.11c-1.308,0.21-2.017,2.518-3.063,3.396 C90.091,232.554,92.531,229.243,89.765,228.085z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M66.364,222.601c-1.509,1.374-2.069,3.934-2.008,6.212c0.068,2.514,0.917,5.153,2.714,6.055 c2.363,1.184,5.391-1.531,5.889-4.832c0.498-3.301-1.127-6.528-3.41-7.919C69.549,222.117,67.873,221.227,66.364,222.601z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M83.08,218.86c0.201,0.213,0.402,0.426,0.602,0.639c-0.983-1.572-3.116-1.656-4.343-0.172 c-1.227,1.484-1.285,4.218-0.117,5.566c1.168,1.348,3.31,1.02,4.361-0.668c1.704,0.915,3.983,0.379,5.23-1.561 c1.246-1.939,1.031-5.174-0.599-6.268c-1.631-1.094-4.176,0.853-4.045,3.254c-0.233-0.325-0.466-0.65-0.698-0.974 L83.08,218.86z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M101.408,221.52c-1.207,1.553-2.463,3.21-2.933,5.274c-0.47,2.064,0.197,4.615,1.791,5.037 c1.585,0.419,3.127-1.35,4.069-3.153c0.85-1.628,1.513-3.632,1.073-5.399c-0.439-1.767-2.448-2.705-3.488-1.26 L101.408,221.52z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M75.123,210.834c-0.571-1.671-2.463-2.152-3.728-1.087c-1.265,1.066-1.765,3.324-1.253,5.03 c0.512,1.706,1.891,2.8,3.348,2.914c1.804,0.141,3.975-1.852,3.61-4.088c0.756,1.262,2.147,1.696,3.433,1.456 c1.287-0.239,2.492-1.055,3.625-1.944c1.538-1.207,3.189-3.029,3.07-5.243c-0.095-1.765-1.415-3.046-2.801-3.125 c-1.387-0.08-2.77,0.827-3.852,2.048c-0.85,0.959-1.564,2.121-2.48,2.973c-0.917,0.851-2.151,1.352-3.105,0.748 L75.123,210.834z"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Keyboard"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 145.683,
    y: 272.761,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 230.668,
    height: 97.147
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150.502,
    y: 278.639,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 21.703,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.831,
    y: 337.203,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 34.184,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.915,
    y: 293.643,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 21.1,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.502,
    y: 322.39,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 21.703,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.502,
    y: 307.922,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 17.569,
    height: 12.014
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150.502,
    y: 293.28,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.836,
    y: 293.28,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.169,
    y: 293.28,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.503,
    y: 293.28,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.837,
    y: 293.28,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.17,
    y: 293.28,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.504,
    y: 293.28,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.838,
    y: 293.28,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.171,
    y: 293.28,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.505,
    y: 293.28,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.839,
    y: 293.28,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.172,
    y: 293.28,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.506,
    y: 293.28,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150.502,
    y: 352.017,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.836,
    y: 352.017,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.169,
    y: 352.017,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.503,
    y: 352.017,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 14.658,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.481,
    y: 352.017,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 73.348,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.49,
    y: 352.017,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.824,
    y: 352.017,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.183,
    y: 352.017,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.83,
    y: 352.017,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 18.653,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.001,
    y: 352.017,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 171.481,
    y: 307.922,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.814,
    y: 307.922,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.148,
    y: 307.922,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.481,
    y: 307.922,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.815,
    y: 307.922,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.149,
    y: 307.922,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.482,
    y: 307.922,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.816,
    y: 307.922,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.15,
    y: 307.922,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.483,
    y: 307.922,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.817,
    y: 307.922,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.15,
    y: 307.922,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "371.015,307.924 371.015,334.578 359.004,334.578  359.004,319.935 355.481,319.935 355.481,307.924  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 174.997,
    y: 322.563,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.331,
    y: 322.563,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.664,
    y: 322.563,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.998,
    y: 322.563,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.332,
    y: 322.563,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.665,
    y: 322.563,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.999,
    y: 322.563,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.333,
    y: 322.563,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.666,
    y: 322.563,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 322.563,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.333,
    y: 322.563,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.667,
    y: 322.563,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 168.48,
    y: 337.203,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.814,
    y: 337.203,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.148,
    y: 337.203,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.481,
    y: 337.203,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.815,
    y: 337.203,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.149,
    y: 337.203,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.482,
    y: 337.203,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.816,
    y: 337.203,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.15,
    y: 337.203,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.483,
    y: 337.203,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.817,
    y: 337.203,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 174.997,
    y: 279.364,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.331,
    y: 279.364,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.664,
    y: 279.364,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.998,
    y: 279.364,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.332,
    y: 279.364,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.665,
    y: 279.364,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.999,
    y: 279.364,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.333,
    y: 279.364,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.666,
    y: 279.364,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 279.364,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.333,
    y: 279.364,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.667,
    y: 279.364,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.001,
    y: 279.364,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 12.014,
    height: 12.014
  })), /*#__PURE__*/React.createElement("rect", {
    x: 150.502,
    y: 337.203,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 14.555,
    height: 12.014
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "145.683,273.384 150.502,271.776 373.218,271.776 376.392,273.363  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Hands"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M310.33,440l-4.69-28.25c-1.03-4.21-3.24-8.04-6.35-11.06c-9.33-9-21.66-18.24-22.19-30.04 c-0.81-18.03-3.62-17.49-3.32-21.94c0.01-0.16,1.4-2.15,3.21-6.6c0.58-1.44,0.97-3.58,1.36-5.34c0.4-1.85,2.16-3.11,4.04-2.85 c1.26,0.17,2.5,0.74,3.39,1.59c1.71,1.66,2.47,4.11,2.54,6.5c0.07,2.38-0.46,4.74-1,7.06c1.68,3.76,2.47,8.33,3.01,12.41 c1.07-3.3,1.88-6.63,2.95-9.92c0.22-0.12,0.14-0.38,0.35-0.5c-1.51-3.24-0.23-3.06-3.22-10.19c-5.03-12-10.64-23.57-14.65-38.65 c-0.32-1.17-0.3-3.09,0.09-4.24c1.45-4.31,5.89-3.32,7.83-0.81c0.52,0.66,0.9,1.4,1.2,2.18c2.05,5.37,6.42,13.65,9.57,18.45 l10.89,16.6c0,0,3.79-3.11,4.37-4.5l0.01-0.01c0.57-1.4,0.85-12.67,0.85-12.67s-0.86,2.11-2.77,1.99c-1.38-0.1-4.18,0.7-6.17-1.54 c-1.63-1.83-1.63-4.58-0.18-6.54l4.93-6.66c0,0,3.31-2.9,7.74-0.93c4.42,1.98,8.71,6.1,8.71,6.1s4.1-0.21,7.58,1.46 c3.49,1.68,7.15,6.5,7.15,6.5s4.07,0.25,5.9,1.58c0.46,0.33,6.67,10,4.43,17.53c-1.33,4.49-2.15,11.01-2.75,12.76l-3.05,44.09 l6.15,29.02l-13.149,7.33c-4.835,2.696-9.899,4.96-15.132,6.766L310.33,440z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    d: "M347.672,388.479l0.118-44.204c0.482-1.787,0.867-8.346,1.894-12.915 c1.733-7.661-5.104-16.896-5.586-17.196c-1.915-1.198-5.992-1.177-5.992-1.177s-3.97-4.569-7.565-6.014 c-3.585-1.434-7.661-0.952-7.661-0.952s-4.548-3.831-9.095-5.511c-4.548-1.669-7.662,1.445-7.662,1.445l-4.473,6.966 c-1.316,2.054-1.134,4.805,0.61,6.517c2.14,2.108,4.879,1.124,6.26,1.124c1.915,0,2.632-2.161,2.632-2.161 s0.471,11.257,0,12.691l-0.011,0.011c-0.492,1.434-4.066,4.783-4.066,4.783l-11.963-15.837 c-3.467-4.58-8.378-12.552-10.775-17.773c-0.353-0.76-0.781-1.477-1.348-2.097c-2.097-2.376-6.591-3.071-7.758,1.327 c-0.31,1.177-0.203,3.092,0.193,4.237c5.008,14.777,11.375,25.949,17.185,37.591c3.456,6.913,2.172,6.827,3.895,9.951 c-0.203,0.139-0.107,0.396-0.321,0.524c-0.845,3.36-1.434,6.731-2.279,10.091c-0.813-4.034-1.905-8.539-3.831-12.177 c0.385-2.354,0.76-4.74,0.524-7.116c-0.225-2.376-1.145-4.772-2.964-6.313c-0.942-0.792-2.215-1.273-3.488-1.359 c-1.894-0.139-3.563,1.241-3.841,3.114c-0.268,1.776-0.514,3.938-1.006,5.414c-1.509,4.558-2.761,6.634-2.761,6.795 c0,4.462,2.761,3.734,4.772,21.679c1.562,13.975,19.56,23.209,29.362,33.3l10.444,32.85 c12.124-4.858,23.723-11.075,34.852-18.298L347.672,388.479z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000008829161814087039730000011948722053385296790_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#XMLID_00000008829161814087039730000011948722053385296790_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M342.546,328.414c0.532-1.3,1.162-2.637,2.296-3.465s2.916-0.933,3.827,0.136 c-0.746-2.294-1.539-4.572-2.377-6.834c-0.638-1.722-1.359-3.514-2.78-4.676c-1.422-1.162-3.764-1.408-4.983-0.034 c0.869,5.216,0.963,10.561,0.28,15.805c-0.37,2.839-0.848,6.104,1.065,8.235c0.527,0.43,1.441-0.342,1.107-0.933 c-0.158-0.28-0.725-0.299-0.969-0.274C340.626,333.659,341.492,330.99,342.546,328.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M342.546,328.414c0.532-1.3,1.162-2.637,2.296-3.465s2.916-0.933,3.827,0.136 c-0.746-2.294-1.539-4.572-2.377-6.834c-0.638-1.722-1.359-3.514-2.78-4.676c-1.422-1.162-3.764-1.408-4.983-0.034 c0.869,5.216,0.963,10.561,0.28,15.805c-0.37,2.839-0.848,6.104,1.065,8.235c0.527,0.43,1.441-0.342,1.107-0.933 c-0.158-0.28-0.725-0.299-0.969-0.274C340.626,333.659,341.492,330.99,342.546,328.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M342.546,328.414c0.532-1.3,1.162-2.637,2.296-3.465s2.916-0.933,3.827,0.136 c-0.746-2.294-1.539-4.572-2.377-6.834c-0.638-1.722-1.359-3.514-2.78-4.676c-1.422-1.162-3.764-1.408-4.983-0.034 c0.869,5.216,0.963,10.561,0.28,15.805c-0.37,2.839-0.848,6.104,1.065,8.235c0.527,0.43,1.441-0.342,1.107-0.933 c-0.158-0.28-0.725-0.299-0.969-0.274C340.626,333.659,341.492,330.99,342.546,328.414z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M326.592,323.669c0.075,1.923,0.063,3.872,0.537,5.737c0.474,1.866,1.512,3.683,3.195,4.616 c-0.992-3.727-0.456-7.668,0.087-11.486c0.329-2.319,0.659-4.639,0.988-6.958c0.115-0.806,0.241-1.646,0.705-2.315 s1.374-1.105,2.114-0.766c-0.988,0.586-2.271-0.199-2.867-1.181c-0.596-0.982-0.831-2.168-1.536-3.075 c-1.337-1.718-4.196-2.098-6.174-1.641C324.242,312.313,326.362,317.766,326.592,323.669z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M326.592,323.669c0.075,1.923,0.063,3.872,0.537,5.737 c0.474,1.866,1.512,3.683,3.195,4.616c-0.992-3.727-0.456-7.668,0.087-11.486c0.329-2.319,0.659-4.639,0.988-6.958 c0.115-0.806,0.241-1.646,0.705-2.315s1.374-1.105,2.114-0.766c-0.988,0.586-2.271-0.199-2.867-1.181 c-0.596-0.982-0.831-2.168-1.536-3.075c-1.337-1.718-4.196-2.098-6.174-1.641 C324.242,312.313,326.362,317.766,326.592,323.669z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M326.592,323.669c0.075,1.923,0.063,3.872,0.537,5.737 c0.474,1.866,1.512,3.683,3.195,4.616c-0.992-3.727-0.456-7.668,0.087-11.486c0.329-2.319,0.659-4.639,0.988-6.958 c0.115-0.806,0.241-1.646,0.705-2.315s1.374-1.105,2.114-0.766c-0.988,0.586-2.271-0.199-2.867-1.181 c-0.596-0.982-0.831-2.168-1.536-3.075c-1.337-1.718-4.196-2.098-6.174-1.641 C324.242,312.313,326.362,317.766,326.592,323.669z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M310.265,308.253c-0.645-0.474-0.86-1.325-1.054-2.102 c-0.195-0.777-0.472-1.627-1.171-2.019c-3.072,1.947-1.393,7.657-4.498,9.551c-0.602,0.367-1.37,0.574-1.705,1.195 c-0.303,0.561-0.11,1.297,0.328,1.76c0.438,0.463,1.071,0.694,1.699,0.807c2.47,0.444,5.073-0.817,6.547-2.848 c1.216-1.675,2.058-4.381,1.457-6.367C311.399,308.493,310.725,308.591,310.265,308.253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M278.342,345.638c-0.055,0.214-0.095,0.481,0.075,0.622 c0.263,0.217,0.614-0.119,0.81-0.398c1.288-1.832,3.839-2.66,5.957-1.934c0.809-0.016,1.084-1.247,0.554-1.859 c-0.53-0.612-1.43-0.718-2.239-0.72c-0.809-0.003-1.675,0.04-2.361-0.389c-0.843-0.528-1.175-1.6-0.96-2.521 C279.634,340.848,278.962,343.242,278.342,345.638z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M310.265,308.253c-0.645-0.474-0.86-1.325-1.054-2.102 c-0.195-0.777-0.472-1.627-1.171-2.019c-3.072,1.947-1.393,7.657-4.498,9.551c-0.602,0.367-1.37,0.574-1.705,1.195 c-0.303,0.561-0.11,1.297,0.328,1.76c0.438,0.463,1.071,0.694,1.699,0.807c2.47,0.444,5.073-0.817,6.547-2.848 c1.216-1.675,2.058-4.381,1.457-6.367C311.399,308.493,310.725,308.591,310.265,308.253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M278.342,345.638c-0.055,0.214-0.095,0.481,0.075,0.622 c0.263,0.217,0.614-0.119,0.81-0.398c1.288-1.832,3.839-2.66,5.957-1.934c0.809-0.016,1.084-1.247,0.554-1.859 c-0.53-0.612-1.43-0.718-2.239-0.72c-0.809-0.003-1.675,0.04-2.361-0.389c-0.843-0.528-1.175-1.6-0.96-2.521 C279.634,340.848,278.962,343.242,278.342,345.638z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M319.055,307.492c-1.749-0.234-3.599-0.277-5.122-1.169 c-1.908-1.118-3.215-3.506-5.424-3.602c-1.963-0.085-3.424,1.714-4.54,3.332c-0.128-2.441,1.667-4.722,3.936-5.63 c2.269-0.908,4.88-0.62,7.152,0.283c2.271,0.903,4.266,2.374,6.205,3.862c0.78,0.598,1.571,1.218,2.098,2.047 C325.826,310.497,320.599,307.698,319.055,307.492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M319.055,307.492c-1.749-0.234-3.599-0.277-5.122-1.169 c-1.908-1.118-3.215-3.506-5.424-3.602c-1.963-0.085-3.424,1.714-4.54,3.332c-0.128-2.441,1.667-4.722,3.936-5.63 c2.269-0.908,4.88-0.62,7.152,0.283c2.271,0.903,4.266,2.374,6.205,3.862c0.78,0.598,1.571,1.218,2.098,2.047 C325.826,310.497,320.599,307.698,319.055,307.492z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#XMLID_00000008829161814087039730000011948722053385296790_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M287.776,364.285c0.12-0.219,0.225-0.445,0.328-0.671 C287.895,363.774,287.756,363.997,287.776,364.285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M290.746,348.794c-0.196-2.465,0.155-4.944,0.052-7.414 c-0.103-2.471-0.749-5.072-2.548-6.768c-2.58-2.432-9.647-1.188-7.277,3.428c0.657,1.279,2.351,1.945,3.668,1.368 c1.317-0.577,1.966-2.369,1.245-3.613c2.857,4.333,2.601,10.485-0.605,14.567c3.664,3.175,4.828,8.859,2.823,13.252 c0.428-0.327,1.175-0.371,1.645-0.017c0.7,0.529,0.935,1.452,1.276,2.26c0.341,0.808,1.003,1.65,1.877,1.591 c1.202-2.945,0.803-6.295,0.023-9.379C292.144,354.985,290.999,351.965,290.746,348.794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M316.619,302.421c-1.376-1.055-3.008-1.771-4.729-1.994L316.619,302.421z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M328.377,333.711c-0.379-1.7-1.164-3.283-1.632-4.961c-1.091-3.911-0.406-8.088-0.906-12.117 c-0.646-5.21-3.365-10.134-7.429-13.456l-1.791-0.755c1.714,1.314,3.028,3.156,3.605,5.239 c1.384,4.775,1.819,9.763,2.433,14.696c0.947,7.609,2.336,15.163,4.157,22.612 C328.006,341.321,329.211,337.456,328.377,333.711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M309.337,315.927c1.238-0.979,1.9-2.544,2.112-4.108c0.189-1.399,0.054-2.816-0.113-4.22 c-0.118,0.603-0.903,1.106-1.572,0.948c-0.851-0.202-1.411-0.99-1.892-1.72c-0.122,0.42-0.243,0.839-0.365,1.259 c-0.049-0.227-0.098-0.454-0.147-0.681l-0.475,0.604c0.709,2.007,1.392,4.336,0.297,6.162 c-0.53,0.884-1.403,1.498-2.251,2.084C306.225,317.157,308.099,316.907,309.337,315.927z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M311.278,307.1c0.02,0.166,0.038,0.332,0.058,0.498 C311.368,307.436,311.361,307.267,311.278,307.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M306.053,327.338c-3.507-6.888-7.016-13.78-10.871-20.479 c-2.254-3.917-4.641-7.789-7.647-11.164c-1.332-1.495-5.16-4.958-7.267-2.677c-1.406,1.521,0.444,4.287-1.287,5.933 c0.397,0.023,2.351-0.19,2.558,0.066c4.392,5.426,6.811,12.414,6.713,19.394c1.412-1.107,3.344,0.43,4.445,1.846 c6.775,8.706,13.108,17.755,18.968,27.102c-1.135-4.131-1.163-8.513-2.389-12.618 C308.505,332.157,307.275,329.739,306.053,327.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M346.787,344.127c1.676-4.485,2.985-9.08,3.133-13.84c0.135-4.326-0.854-8.819-3.14-12.525 c-0.578-0.937-2.981-4.769-4.296-4.458c-2.347,0.556,0.735,4.637,1.272,5.656c2.028,3.849,4.111,7.92,3.981,12.268 c-0.1,3.351-1.51,6.498-2.636,9.656c-0.785,2.201-1.425,4.554-1.409,6.861c-0.173,0.256-0.331,0.523-0.519,0.769 c-1.558,2.043-3.746,3.728-6.282,4.141c0.966-2.983,1.933-5.967,2.899-8.95c0.345-1.065,0.469-2.521-0.15-3.262 c0.2-0.408,0.324-0.839,0.306-1.303c-0.032-0.822-0.501-1.551-0.848-2.297c-1.338-2.882-0.885-6.231-0.559-9.392 c0.401-3.899,0.553-7.915-0.59-11.664c-1.144-3.749-3.79-7.226-7.507-8.47c0.318,0.343,0.636,0.686,0.954,1.029l-1.26-0.916 c0.781,1.625,1.563,3.25,2.344,4.875c-0.288,0.411-0.576,0.822-0.864,1.234c1.29-0.676,2.943,0.304,3.534,1.635 c0.591,1.331,0.429,2.857,0.293,4.307c-0.76,8.087-0.351,16.279,1.18,24.256c-0.146,1.862-0.469,3.748-1.439,5.336 c-1.048,1.714-3.013,3.002-5.001,2.711c0.44-1.921-0.301-4.194-1.928-5.33c-2.016,2.799-0.829,7.15-0.522,10.337 c0.465,4.831,1.241,9.632,2.322,14.363c0.31-4.103,1.171-8.163,2.552-12.039c1.088,3.949,2.176,7.898,3.263,11.847 c0.034-1.105,0.08-2.259,0.616-3.226c0.536-0.967,1.725-1.67,2.76-1.28c0.847,0.32,1.306,1.22,1.654,2.056 c2.827,6.788,3.539,14.441,2.012,21.634c1.343,0.745,3.12-0.156,3.864-1.499c0.745-1.343,0.737-2.96,0.71-4.495 C347.253,370.809,347.02,357.468,346.787,344.127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M312.887,348.359c-0.641,1.124,1.979,5.585,2.413,6.644 c2.204,5.381,4.408,10.762,6.612,16.143c-0.73-7.085-2.462-14.067-5.126-20.673 C316.336,349.357,314.159,346.129,312.887,348.359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M316.31,319.839c-0.375,0.569-0.913,1.269-1.564,1.069c-0.608-0.186-0.711-0.989-0.701-1.624 c0.061-3.744,0.122-7.487,0.183-11.231c-3.022,2.165-2.635,5.005-2.847,8.237c-0.123,1.871,0.419,10.796-0.858,11.89 c2.988-2.549,5.52-5.63,7.441-9.055C317.439,318.69,316.685,319.27,316.31,319.839z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M287.776,364.285c0.12-0.219,0.225-0.445,0.328-0.671 C287.895,363.774,287.756,363.997,287.776,364.285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M290.746,348.794c-0.196-2.465,0.155-4.944,0.052-7.414 c-0.103-2.471-0.749-5.072-2.548-6.768c-2.58-2.432-9.647-1.188-7.277,3.428c0.657,1.279,2.351,1.945,3.668,1.368 c1.317-0.577,1.966-2.369,1.245-3.613c2.857,4.333,2.601,10.485-0.605,14.567c3.664,3.175,4.828,8.859,2.823,13.252 c0.428-0.327,1.175-0.371,1.645-0.017c0.7,0.529,0.935,1.452,1.276,2.26c0.341,0.808,1.003,1.65,1.877,1.591 c1.202-2.945,0.803-6.295,0.023-9.379C292.144,354.985,290.999,351.965,290.746,348.794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M316.619,302.421c-1.376-1.055-3.008-1.771-4.729-1.994L316.619,302.421z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M328.377,333.711c-0.379-1.7-1.164-3.283-1.632-4.961 c-1.091-3.911-0.406-8.088-0.906-12.117c-0.646-5.21-3.365-10.134-7.429-13.456l-1.791-0.755 c1.714,1.314,3.028,3.156,3.605,5.239c1.384,4.775,1.819,9.763,2.433,14.696c0.947,7.609,2.336,15.163,4.157,22.612 C328.006,341.321,329.211,337.456,328.377,333.711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M309.337,315.927c1.238-0.979,1.9-2.544,2.112-4.108c0.189-1.399,0.054-2.816-0.113-4.22 c-0.118,0.603-0.903,1.106-1.572,0.948c-0.851-0.202-1.411-0.99-1.892-1.72c-0.122,0.42-0.243,0.839-0.365,1.259 c-0.049-0.227-0.098-0.454-0.147-0.681l-0.475,0.604c0.709,2.007,1.392,4.336,0.297,6.162 c-0.53,0.884-1.403,1.498-2.251,2.084C306.225,317.157,308.099,316.907,309.337,315.927z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M311.278,307.1c0.02,0.166,0.038,0.332,0.058,0.498 C311.368,307.436,311.361,307.267,311.278,307.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M306.053,327.338c-3.507-6.888-7.016-13.78-10.871-20.479 c-2.254-3.917-4.641-7.789-7.647-11.164c-1.332-1.495-5.16-4.958-7.267-2.677c-1.406,1.521,0.444,4.287-1.287,5.933 c0.397,0.023,2.351-0.19,2.558,0.066c4.392,5.426,6.811,12.414,6.713,19.394c1.412-1.107,3.344,0.43,4.445,1.846 c6.775,8.706,13.108,17.755,18.968,27.102c-1.135-4.131-1.163-8.513-2.389-12.618 C308.505,332.157,307.275,329.739,306.053,327.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M346.787,344.127c1.676-4.485,2.985-9.08,3.133-13.84c0.135-4.326-0.854-8.819-3.14-12.525 c-0.578-0.937-2.981-4.769-4.296-4.458c-2.347,0.556,0.735,4.637,1.272,5.656c2.028,3.849,4.111,7.92,3.981,12.268 c-0.1,3.351-1.51,6.498-2.636,9.656c-0.785,2.201-1.425,4.554-1.409,6.861c-0.173,0.256-0.331,0.523-0.519,0.769 c-1.558,2.043-3.746,3.728-6.282,4.141c0.966-2.983,1.933-5.967,2.899-8.95c0.345-1.065,0.469-2.521-0.15-3.262 c0.2-0.408,0.324-0.839,0.306-1.303c-0.032-0.822-0.501-1.551-0.848-2.297c-1.338-2.882-0.885-6.231-0.559-9.392 c0.401-3.899,0.553-7.915-0.59-11.664c-1.144-3.749-3.79-7.226-7.507-8.47c0.318,0.343,0.636,0.686,0.954,1.029 l-1.26-0.916c0.781,1.625,1.563,3.25,2.344,4.875c-0.288,0.411-0.576,0.822-0.864,1.234 c1.29-0.676,2.943,0.304,3.534,1.635c0.591,1.331,0.429,2.857,0.293,4.307c-0.76,8.087-0.351,16.279,1.18,24.256 c-0.146,1.862-0.469,3.748-1.439,5.336c-1.048,1.714-3.013,3.002-5.001,2.711c0.44-1.921-0.301-4.194-1.928-5.33 c-2.016,2.799-0.829,7.15-0.522,10.337c0.465,4.831,1.241,9.632,2.322,14.363c0.31-4.103,1.171-8.163,2.552-12.039 c1.088,3.949,2.176,7.898,3.263,11.847c0.034-1.105,0.08-2.259,0.616-3.226c0.536-0.967,1.725-1.67,2.76-1.28 c0.847,0.32,1.306,1.22,1.654,2.056c2.827,6.788,3.539,14.441,2.012,21.634c1.343,0.745,3.12-0.156,3.864-1.499 c0.745-1.343,0.737-2.96,0.71-4.495C347.253,370.809,347.02,357.468,346.787,344.127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M312.887,348.359c-0.641,1.124,1.979,5.585,2.413,6.644 c2.204,5.381,4.408,10.762,6.612,16.143c-0.73-7.085-2.462-14.067-5.126-20.673 C316.336,349.357,314.159,346.129,312.887,348.359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M316.31,319.839c-0.375,0.569-0.913,1.269-1.564,1.069 c-0.608-0.186-0.711-0.989-0.701-1.624c0.061-3.744,0.122-7.487,0.183-11.231c-3.022,2.165-2.635,5.005-2.847,8.237 c-0.123,1.871,0.419,10.796-0.858,11.89c2.988-2.549,5.52-5.63,7.441-9.055C317.439,318.69,316.685,319.27,316.31,319.839z "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M323.966,307.592c1.766,6.52,2.685,13.267,2.728,20.022c0.007,1.13-0.006,2.286,0.356,3.357 c0.362,1.071,1.186,2.062,2.294,2.285"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M338.109,314.161c2.969,6.262-0.07,20.245,0.155,21.23c0.224,0.985,0.786,1.942,1.685,2.402"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M312.327,306.735c-0.349,1.99-0.641,4.298-0.991,6.288c-2.324-1.978-3.804-4.917-4.009-7.962"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M293.169,360.092c-0.719,0.317-1.439,0.634-2.158,0.95"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M293.722,361.824c-0.352,1.661-0.36,3.395-0.023,5.059"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M306.358,343.135c0.798,1.437,1.596,2.873,2.395,4.31"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M310.955,327.364c0.793-1.121,1.587-2.242,2.38-3.362"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M344.431,343.135c-0.24,0.878-0.479,1.756-0.718,2.634"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M338.61,335.928c0.702-2.24,1.404-4.48,2.105-6.72"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M345.648,324.012c1.235-0.716,3.029-0.158,3.639,1.133"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M331.275,312.533c1.652-0.481,3.54-0.049,4.818,1.102"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M286.736,319.201c1.536-1.707,3.924-2.607,6.205-2.337"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M277.714,300.339c1.43-1.046,3.291-1.482,5.036-1.179"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M279.569,345.087c-1.158,0.918-2.155,2.04-2.932,3.297L279.569,345.087z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M280.53,340.547c1.581-1.13,4.1,1.397,5.553,0.108c0.579-0.514,0.622-1.404,0.488-2.166 c-0.134-0.762-0.402-1.526-0.289-2.291"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M325.12,333.612c1.92,3.944,2.319,8.604,1.098,12.817"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M336.735,339.779c0.316,1.874-0.046,3.855-1.003,5.497"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M321.113,436.085l-10.444-32.85 c-9.802-10.091-27.8-19.325-29.362-33.3c-2.012-17.945-4.772-17.217-4.772-21.679c0-0.161,1.252-2.236,2.761-6.795 c0.492-1.477,0.738-3.638,1.006-5.414c0.278-1.872,1.947-3.253,3.841-3.114c1.273,0.086,2.547,0.567,3.488,1.359 c1.819,1.541,2.739,3.938,2.964,6.313c0.236,2.375-0.139,4.762-0.524,7.116c1.926,3.638,3.018,8.143,3.831,12.177 c0.845-3.36,1.434-6.731,2.279-10.091c0.214-0.128,0.118-0.385,0.321-0.524c-1.723-3.125-0.439-3.039-3.895-9.951 c-5.81-11.642-12.177-22.813-17.185-37.591c-0.396-1.145-0.503-3.06-0.193-4.237c1.166-4.398,5.661-3.702,7.758-1.327 c0.567,0.621,0.995,1.338,1.348,2.097c2.397,5.222,7.308,13.194,10.775,17.773l11.963,15.837c0,0,3.574-3.349,4.066-4.783 l0.011-0.011c0.471-1.434,0-12.691,0-12.691s-0.717,2.161-2.632,2.161c-1.38,0-4.12,0.984-6.26-1.124 c-1.744-1.712-1.926-4.462-0.61-6.517l4.473-6.966c0,0,3.114-3.114,7.662-1.444c4.548,1.68,9.095,5.511,9.095,5.511 s4.077-0.482,7.661,0.952c3.595,1.445,7.565,6.014,7.565,6.014s4.077-0.021,5.992,1.177c0.482,0.3,7.319,9.534,5.586,17.196 c-1.027,4.569-1.413,11.129-1.894,12.915l-0.118,44.204l8.293,29.309"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M323.966,307.592c1.766,6.52,2.685,13.267,2.728,20.022 c0.007,1.13-0.006,2.286,0.356,3.357c0.362,1.071,1.186,2.062,2.294,2.285"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M338.109,314.161c2.969,6.262-0.07,20.245,0.155,21.23 c0.224,0.985,0.786,1.942,1.685,2.402"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M312.327,306.735c-0.349,1.99-0.641,4.298-0.991,6.288 c-2.324-1.978-3.804-4.917-4.009-7.962"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M293.169,360.092c-0.719,0.317-1.439,0.634-2.158,0.95"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M293.722,361.824c-0.352,1.661-0.36,3.395-0.023,5.059"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M306.358,343.135c0.798,1.437,1.596,2.873,2.395,4.31"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M310.955,327.364c0.793-1.121,1.587-2.242,2.38-3.362"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M344.431,343.135c-0.24,0.878-0.479,1.756-0.718,2.634"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M338.61,335.928c0.702-2.24,1.404-4.48,2.105-6.72"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M345.648,324.012c1.235-0.716,3.029-0.158,3.639,1.133"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M331.275,312.533c1.652-0.481,3.54-0.049,4.818,1.102"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M286.736,319.201c1.536-1.707,3.924-2.607,6.205-2.337"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M277.714,300.339c1.43-1.046,3.291-1.482,5.036-1.179"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M279.569,345.087c-1.158,0.918-2.155,2.04-2.932,3.297"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M280.53,340.547c1.581-1.13,4.1,1.397,5.553,0.108 c0.579-0.514,0.622-1.404,0.488-2.166c-0.134-0.762-0.402-1.526-0.289-2.291"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M325.12,333.612c1.92,3.944,2.319,8.604,1.098,12.817"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M336.735,339.779c0.316,1.874-0.046,3.855-1.003,5.497"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M240.05,354.79c0.09,0.69,0.06,1.4-0.09,2.08c-0.65,3.01-2.53,11.78-3.22,16.58 c-0.82,5.86-10.29,24-10.29,24s-8.72,10.84-13.16,16.48c-2.18,2.77-5.63,13.98-8.56,24.66c-3.7-1.12-7.36-2.33-11-3.62 c-3.01-1.07-6.02-2.2-8.99-3.37c-4.18-1.65-9.51-4.27-15.63-7.62c1.66-6.03,2.77-10.67,2.75-10.94c-0.05-0.63,3.56-7.58,3.56-7.58 l-3.15-41.44l-1.86-6.31c-0.97-3.26-1.58-6.62-1.83-9.98c-0.39-5.13,0.04-10.3,1.29-15.33l5.43-8.06l2.54-0.19l7.86-10.98 c0,0,4.25-1.28,5.34,1.92c1.09,3.21-3.54,9.18-3.54,9.18l-1.59,9.87l3.78,9.24l1.96,0.72c0,0,0.66-16.27,0.21-19.52l4.18-14.85 c0,0,2.49-4.96,3.26-7.46c0.76-2.49,5.23-4.96,7.8-0.59c0,0,1.43,2.22,0.4,5.27c-1.05,3.05-1.92,5.45-1.92,5.45 s-0.95,12.58-1.25,12.93c-0.3,0.33,1.85,18.73,1.85,18.73l1.64,0.73l0.58-17.55l3.41-16.49c0,0-0.28-7.93,5.31-6.97 c0,0,2.62-0.3,4.11,2.56c1.49,2.85,0.07,21.83,0.07,21.83l1.38,19.62l2.21,15.13l2.6-10.37c0,0,0.15-14.86,9.53-16.13 c0,0,2.79-0.5,3.36,1.44c0.57,1.93-1.39,5.9-1.11,9.7C239.48,350.23,239.86,353.24,240.05,354.79z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    d: "M237.2,336.421c-0.428-1.98-3.242-1.691-3.242-1.691c-9.449,0.556-10.722,15.366-10.722,15.366 l-3.381,10.144l-1.059-15.259l0.107-19.667c0,0,2.857-18.822,1.584-21.776c-1.263-2.964-3.906-2.857-3.906-2.857 c-5.5-1.38-5.821,6.549-5.821,6.549l-4.644,16.179l-1.905,17.452l-1.584-0.845c0,0-0.749-18.512-0.428-18.822 c0.321-0.321,2.226-12.798,2.226-12.798s1.049-2.322,2.322-5.286c1.263-2.964,0-5.286,0-5.286c-2.226-4.548-6.87-2.429-7.822,0 c-0.952,2.429-3.809,7.191-3.809,7.191l-5.297,14.488c0.203,3.274-1.68,19.454-1.68,19.454l-1.905-0.867l-3.071-9.502 l2.333-9.727c0,0,5.072-5.596,4.227-8.881c-0.845-3.274-5.179-2.322-5.179-2.322l-8.667,10.358h-2.547l-6.024,7.619 c-1.626,4.922-2.451,10.048-2.451,15.195c0,3.371,0.353,6.763,1.07,10.091l1.38,6.431v41.561c0,0-4.12,6.656-4.12,7.287 c0,0.289-1.701,5.543-4.077,12.091c10.369,6.099,19.304,10.818,25.628,13.311c2.975,1.177,5.981,2.301,8.999,3.371 c3.799-10.668,8.239-22.086,10.69-24.75c4.858-5.286,14.371-15.441,14.371-15.441s10.818-17.367,12.081-23.145 c1.049-4.74,3.585-13.343,4.462-16.297c0.203-0.663,0.289-1.37,0.246-2.065c-0.075-1.562-0.225-4.591-0.225-7.266 C235.36,342.199,237.617,338.39,237.2,336.421z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_1_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000090976379669127310060000017995822459331530935_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000090976379669127310060000017995822459331530935_)",
      fill: "#92E3A9"
    },
    d: "M172.305,332.238 c1.614-2.014,4.936-2.788,6.813-1.017c1.077,1.016,1.44,2.559,1.713,4.014c0.273,1.455,0.544,2.996,1.509,4.119 c0.964,1.123,2.891,1.563,3.905,0.486c0.134,2.19,0.269,4.38,0.403,6.569c2.336-4.056,3.541-8.756,3.444-13.436 c-0.047-2.274-0.39-4.586,0.137-6.799s2.245-4.366,4.517-4.47c2.52-0.115,4.513,2.34,4.997,4.816 c0.484,2.476-0.083,5.019-0.237,7.538c-0.234,3.84,0.518,7.737,2.165,11.214c0.529-1.072,1.059-2.145,1.588-3.217 c0.477,2.152,0.954,4.303,1.431,6.455c0.413-4.735,0.827-9.471,1.24-14.206c0.117-1.338,0.245-2.716,0.868-3.905 c0.623-1.189,1.875-2.155,3.211-2.021c1.801,0.179,2.837,2.101,3.441,3.807c4.505,12.741,2.649,26.741,0.739,40.12 c1.253,0.223,2.305-1.035,2.618-2.268c0.313-1.233,0.201-2.565,0.669-3.748c0.468-1.183,1.917-2.159,2.993-1.481 c1.575,0.992,0.475,4.065,2.131,4.914c0.513-3.957,2.092-7.771,4.527-10.933c1.109-1.44,2.774-2.868,4.533-2.411 c1.313,0.341,2.17,1.682,2.363,3.025c0.193,1.343,2.13-4.202,1.797-2.887c0.757-7.714-0.758-8.527-0.001-16.241 c0.137-1.393,2.389-3.807,1.431-4.827c-0.911-0.97-3.63-2.392-4.838-1.833c-1.208,0.559-5.138,2.513-5.919,3.591 c-4.913,6.784-4.579,16.61-6.107,24.846c-1.304-12.56-2.601-25.327-0.299-37.743c1.27-6.849,3.611-13.982,1.399-20.587 c-1.009-3.015-3.688-6.03-6.815-5.457c-2.524,0.462-4.049,3.006-5.074,5.358c-3.443,7.901-4.973,16.48-6.475,24.967 c1.879-8.541,3.758-17.082,5.637-25.623c0.488-2.22,0.979-4.51,0.575-6.746c-0.404-2.236-1.932-4.43-4.156-4.898 c-2.207-0.464-4.399,0.841-6.063,2.363c-5.944,5.438-8.157,13.734-10.095,21.554c0.68-2.043,1.369-4.16,1.159-6.302 c-0.21-2.143-1.573-4.329-3.676-4.791c-2.722-0.598-5.196,1.834-6.392,4.351c-1.196,2.518-1.786,5.414-3.691,7.448 c-1.39-1.564-4.001-1.473-5.746-0.318c-1.745,1.155-2.798,3.09-3.65,5.001c-3.128,7.017-4.471,14.822-3.868,22.482 c1.379-3.075,4.865-5.059,8.212-4.675c-0.199-1.704-0.398-3.408-0.597-5.112"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#XMLID_00000090976379669127310060000017995822459331530935_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M178.887,348.508c-0.084,1.262-0.169,2.524-0.253,3.787c0.386-1.052,1.929-1.443,2.77-0.703 c-0.187-0.802,0.312-1.58,0.629-2.34c0.317-0.76,0.351-1.839-0.389-2.201c-0.879-0.43-1.749,0.58-2.212,1.442 c-0.039-0.313-0.078-0.626-0.116-0.939L178.887,348.508z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M193.233,346.246c-1.031,1.179-1.737,2.64-2.018,4.181c0.435-0.426,0.888-0.864,1.461-1.072 c0.572-0.208,1.3-0.119,1.663,0.371c0.226,0.305,0.306,0.744,0.643,0.918c0.339,0.176,0.775-0.036,0.977-0.36 c0.202-0.324,0.232-0.722,0.255-1.103c0.045-0.728,0.089-1.474-0.122-2.173c-0.211-0.698-0.732-1.35-1.445-1.504 c-0.713-0.154-1.558,0.37-1.564,1.099L193.233,346.246z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M207.119,349.693c-1.096,1.473-1.822,3.218-2.096,5.034c0.736-0.107,1.354-0.588,1.943-1.044 c0.588-0.455,1.229-0.918,1.97-0.976c0.742-0.057,1.577,0.478,1.555,1.222c-0.142-0.839-0.007-1.696,0.082-2.542 c0.089-0.846,0.129-1.729-0.187-2.519c-0.316-0.79-1.077-1.46-1.926-1.414c-0.849,0.046-1.579,1.039-1.182,1.791 L207.119,349.693z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M168.909,354.709c-0.769,1.44-1.173,3.073-1.165,4.705c0.01-0.752,0.718-1.36,1.462-1.466 c0.744-0.107,1.491,0.182,2.137,0.568c0.149-0.756,0.298-1.538,0.139-2.292s-0.706-1.483-1.467-1.605 c-0.761-0.123-1.603,0.612-1.394,1.354c-0.079-0.192-0.157-0.385-0.236-0.577L168.909,354.709z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    style: {
      opacity: 0.5,
      clipPath: "url(#XMLID_00000090976379669127310060000017995822459331530935_)",
      fill: "#FFFFFF"
    },
    d: " M172.305,332.238c1.614-2.014,4.936-2.788,6.813-1.017c1.077,1.016,1.44,2.559,1.713,4.014c0.273,1.455,0.544,2.996,1.509,4.119 c0.964,1.123,2.891,1.563,3.905,0.486c0.134,2.19,0.269,4.38,0.403,6.569c2.336-4.056,3.541-8.756,3.444-13.436 c-0.047-2.274-0.39-4.586,0.137-6.799s2.245-4.366,4.517-4.47c2.52-0.115,4.513,2.34,4.997,4.816 c0.484,2.476-0.083,5.019-0.237,7.538c-0.234,3.84,0.518,7.737,2.165,11.214c0.529-1.072,1.059-2.145,1.588-3.217 c0.477,2.152,0.954,4.303,1.431,6.455c0.413-4.735,0.827-9.471,1.24-14.206c0.117-1.338,0.245-2.716,0.868-3.905 c0.623-1.189,1.875-2.155,3.211-2.021c1.801,0.179,2.837,2.101,3.441,3.807c4.505,12.741,2.649,26.741,0.739,40.12 c1.253,0.223,2.305-1.035,2.618-2.268c0.313-1.233,0.201-2.565,0.669-3.748c0.468-1.183,1.917-2.159,2.993-1.481 c1.575,0.992,0.475,4.065,2.131,4.914c0.513-3.957,2.092-7.771,4.527-10.933c1.109-1.44,2.774-2.868,4.533-2.411 c1.313,0.341,2.17,1.682,2.363,3.025c0.193,1.343,2.13-4.202,1.797-2.887c0.757-7.714-0.758-8.527-0.001-16.241 c0.137-1.393,2.389-3.807,1.431-4.827c-0.911-0.97-3.63-2.392-4.838-1.833c-1.208,0.559-5.138,2.513-5.919,3.591 c-4.913,6.784-4.579,16.61-6.107,24.846c-1.304-12.56-2.601-25.327-0.299-37.743c1.27-6.849,3.611-13.982,1.399-20.587 c-1.009-3.015-3.688-6.03-6.815-5.457c-2.524,0.462-4.049,3.006-5.074,5.358c-3.443,7.901-4.973,16.48-6.475,24.967 c1.879-8.541,3.758-17.082,5.637-25.623c0.488-2.22,0.979-4.51,0.575-6.746c-0.404-2.236-1.932-4.43-4.156-4.898 c-2.207-0.464-4.399,0.841-6.063,2.363c-5.944,5.438-8.157,13.734-10.095,21.554c0.68-2.043,1.369-4.16,1.159-6.302 c-0.21-2.143-1.573-4.329-3.676-4.791c-2.722-0.598-5.196,1.834-6.392,4.351c-1.196,2.518-1.786,5.414-3.691,7.448 c-1.39-1.564-4.001-1.473-5.746-0.318c-1.745,1.155-2.798,3.09-3.65,5.001c-3.128,7.017-4.471,14.822-3.868,22.482 c1.379-3.075,4.865-5.059,8.212-4.675c-0.199-1.704-0.398-3.408-0.597-5.112"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      clipPath: "url(#XMLID_00000090976379669127310060000017995822459331530935_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M178.887,348.508c-0.084,1.262-0.169,2.524-0.253,3.787c0.386-1.052,1.929-1.443,2.77-0.703 c-0.187-0.802,0.312-1.58,0.629-2.34c0.317-0.76,0.351-1.839-0.389-2.201c-0.879-0.43-1.749,0.58-2.212,1.442 c-0.039-0.313-0.078-0.626-0.116-0.939L178.887,348.508z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M193.233,346.246c-1.031,1.179-1.737,2.64-2.018,4.181c0.435-0.426,0.888-0.864,1.461-1.072 c0.572-0.208,1.3-0.119,1.663,0.371c0.226,0.305,0.306,0.744,0.643,0.918c0.339,0.176,0.775-0.036,0.977-0.36 c0.202-0.324,0.232-0.722,0.255-1.103c0.045-0.728,0.089-1.474-0.122-2.173c-0.211-0.698-0.732-1.35-1.445-1.504 c-0.713-0.154-1.558,0.37-1.564,1.099L193.233,346.246z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M207.119,349.693c-1.096,1.473-1.822,3.218-2.096,5.034c0.736-0.107,1.354-0.588,1.943-1.044 c0.588-0.455,1.229-0.918,1.97-0.976c0.742-0.057,1.577,0.478,1.555,1.222c-0.142-0.839-0.007-1.696,0.082-2.542 c0.089-0.846,0.129-1.729-0.187-2.519c-0.316-0.79-1.077-1.46-1.926-1.414c-0.849,0.046-1.579,1.039-1.182,1.791 L207.119,349.693z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M168.909,354.709c-0.769,1.44-1.173,3.073-1.165,4.705c0.01-0.752,0.718-1.36,1.462-1.466 c0.744-0.107,1.491,0.182,2.137,0.568c0.149-0.756,0.298-1.538,0.139-2.292s-0.706-1.483-1.467-1.605 c-0.761-0.123-1.603,0.612-1.394,1.354c-0.079-0.192-0.157-0.385-0.236-0.577L168.909,354.709z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M159.108,418.29c2.375-6.549,4.077-11.803,4.077-12.091 c0-0.631,4.12-7.287,4.12-7.287v-41.561l-1.38-6.431c-0.717-3.328-1.07-6.72-1.07-10.091c0-5.147,0.824-10.272,2.45-15.195 l6.024-7.619h2.547l8.667-10.358c0,0,4.334-0.952,5.179,2.322c0.845,3.285-4.227,8.881-4.227,8.881l-2.333,9.727l3.071,9.502 l1.905,0.867c0,0,1.883-16.179,1.68-19.454l5.297-14.488c0,0,2.857-4.762,3.809-7.191c0.952-2.429,5.596-4.548,7.822,0 c0,0,1.263,2.322,0,5.286c-1.273,2.964-2.322,5.286-2.322,5.286s-1.905,12.477-2.226,12.798 c-0.321,0.31,0.428,18.822,0.428,18.822l1.584,0.845l1.905-17.453l4.644-16.179c0,0,0.321-7.929,5.821-6.549 c0,0,2.643-0.107,3.906,2.857c1.273,2.953-1.584,21.776-1.584,21.776l-0.107,19.667l1.059,15.259l3.381-10.144 c0,0,1.273-14.81,10.722-15.366c0,0,2.814-0.289,3.242,1.691c0.417,1.969-1.84,5.778-1.84,9.588c0,2.675,0.15,5.703,0.225,7.266 c0.043,0.696-0.043,1.402-0.246,2.065c-0.877,2.953-3.413,11.557-4.462,16.297c-1.263,5.778-12.081,23.145-12.081,23.145 s-9.513,10.155-14.371,15.441c-2.45,2.664-6.891,14.082-10.69,24.75"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M187.965,340.522c0.553,1.971-0.007,4.215-1.421,5.695"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M171.838,354.504c1.377-2.127,2.712-5.049,2.343-7.556 c-0.723-4.908-2.959-10.559-1.953-15.417c0.643-3.104,1.286-6.207,1.929-9.311"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M211.708,308.123c1.626-0.427,3.364-0.423,4.987,0.014 c0.019-0.464,0.038-0.928,0.057-1.392"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M198.578,301.876c0.958,0.687,2.308,0.779,3.35,0.228 c1.042-0.551,1.727-1.719,1.698-2.897"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M234.72,336.59c-2.775,0.633-4.853,3.5-4.59,6.335 c0.817,0.244,1.635,0.487,2.452,0.731"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M202.537,337.811c0.111,1.677-0.094,5.689,0.018,7.365"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M204.38,340.136c-0.202,2.748-0.404,5.497-0.607,8.245 c0.016-0.35,0.033-0.699,0.049-1.049"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M219.636,363.311c0.733,3.008,0.397,6.264-0.935,9.059"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M194.288,348.901c-2.18,2.391-1.86,8.124-0.32,11.279"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M210.399,352.846c0.054,2.58-0.888,5.169-2.668,7.334"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M178.409,350.045c-0.361,2.401,0.179,4.927,1.492,6.969"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M169.133,357.51c-0.106,1.885,0.446,3.801,1.54,5.341"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M181.847,311.407c1.132-0.548,2.595-0.313,3.499,0.561 c0.412-0.544,0.824-1.087,1.236-1.631"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M192.108,318.747c1.653-1.052,4.074-0.641,5.287,0.898"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M208.134,323.749c1.785-0.808,3.934-0.763,5.683,0.119"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M172.475,332.139c1.035-1.788,3.191-2.858,5.241-2.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M165.77,341.705c0.027-1.293,1.089-2.486,2.371-2.662"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Coffee"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 423.435,
    cy: 228.393,
    r: 41.447
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M470.36,229.477c-8.837,14.495-11.98,12.537-42.125,26.977 c-15.303,7.331-30.091-16.237-20.087-40.425c0.488-1.18,4.811-7.15,4.811-7.15c1.82-8,8.46-14.7,16.45-16.58 c7.98-1.89,16.92,1.12,22.13,7.46c5.66-5.01,13.87-6.87,21.18-5.06c0.35,1.02,0.68,2.02,1,3c0.12,0.38,0.25,0.75,0.36,1.13 c0.38,1.17,0.74,2.34,1.07,3.52c0.66,2.24,1.27,4.49,1.84,6.76c-3.33-0.93-6.68-0.95-9.84,0.59c-2.21,1.08-4.06,2.86-6.36,3.74 c-2.3,0.87-5.48,0.38-6.36-1.92c1.11,4.62,5.957,3.239,10.615,4.153C472.254,217.089,474.08,223.377,470.36,229.477z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M456.745,222.334c0,0,7.42-1.006,10.945-0.478c2.237,0.335,3.61,1.637,4.267,2.449c0.304,0.376,0.479,0.84,0.512,1.323 l0.398,5.798c0.045,0.662-0.179,1.319-0.639,1.798c-1.447,1.506-5.819,4.256-18.754,5.245 C435.284,239.859,456.745,222.334,456.745,222.334z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M451.325,207.344c2.088,2.595,6.073,8.487,6.073,17.63c0,6.91-8.003,30.511-28.493,33.384 c-21.689,3.041-39.125-15.522-35.401-37.859C396.08,205.049,433.913,185.704,451.325,207.344z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 424.824,
    cy: 223.415,
    rx: 31.47,
    ry: 29.787
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#263238"
    },
    cx: 424.759,
    cy: 224.974,
    rx: 25.835,
    ry: 24.453
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M456.294,223.415c0-16.451-14.09-29.786-31.47-29.786c-17.38,0-31.47,13.336-31.47,29.786"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M447.99,243.575 c5.155-5.305,8.303-12.385,8.303-20.16"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M402.779,244.672c5.678,5.276,13.46,8.529,22.045,8.529c5.272,0,10.242-1.227,14.607-3.396"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M398.239,239.362c0.412,0.615,0.848,1.214,1.305,1.797"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M393.354,223.415c0,4.546,1.076,8.853,2.999,12.708"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M471.007,231.566c0,0-5.611-3.921-14.713-0.366"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M466.177,234.293c-2.146,0.636-5.746,1.372-11.638,1.828"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M469.093,233.054c0,0-0.339,0.299-1.403,0.722"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M474.08,198.83c-0.11-0.38-0.24-0.75-0.36-1.13c-1.91-5.92-4.37-12.42-7.36-19.28 c-0.55-1.27-1.13-2.56-1.71-3.86c-0.23,0.02-0.45,0.04-0.67,0.06c-2.87,0.29-5.89,0.65-8.25,2.28 c-2.37,1.66-3.77,5.07-2.24,7.52c1.5,2.43,5.43,3.78,4.81,6.55c-6.41,3.61-14.23,3.19-21.36,5.01 c-4.29,1.09-8.35,3.02-11.91,5.62c-0.01,0-0.01,0.01-0.02,0.01c-1.13,0.85-2.22,1.75-3.24,2.72c-0.45,0.43-0.92,0.9-1.32,1.42 c-0.01,0.01-0.01,0.01-0.01,0.02c-0.59,0.75-1.04,1.59-1.13,2.54c-0.25,2.67,2.18,4.49,4.77,5.65 c0.48,0.22,0.45,0.91-0.04,1.08c-1.69,0.68-3.34,1.47-4.67,2.7c-0.01,0-0.02,0.01-0.03,0.02c-0.82,0.74-0.15,2.13,0.97,1.98 c0.12-0.02,0.27-0.03,0.4-0.04c1.1-0.08,2.13,0.05,3.02,0.36c1.53,0.54,2.6,1.58,2.71,2.86c0.16,2.03-2.15,3.86-5.15,4.09 c-0.73,0.07-0.17,0.94,0.9,1.12c2.13,0.38,4.3-0.03,6.4-0.52c2.51-0.6,5.19-1.47,6.61-3.62c0.6-0.91,0.78-2.1,0.6-3.18 c-0.25-1.48-1.18-2.77-2.66-2.92c4.64-0.55,9.24-1.47,13.72-2.75h0.01l1.41-0.43c1.34-0.4,2.75-0.89,3.87-1.69 c0.7-0.5,1.28-1.09,1.69-1.86c1.04-2.01-0.43-5.19-2.65-4.77c6.45-2.53,13.27-4.01,19.79-6.34 C472.02,199.67,473.06,199.27,474.08,198.83z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Monitor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M424.64,112.33c-6.04,5.37-12.94,9.93-19.9,14.04c-36.41,21.54-77.54,34.44-119.38,40.73 c-41.83,6.29-84.44,6.1-126.6,2.63c-8.28-0.68-16.7-1.52-24.31-4.86c-6.45-2.84-12.3-7.78-15.04-14.17 c9.13-10.4,17.62-20.92,27.07-30.85c2.25-2.37,4.55-4.7,6.92-6.99c2-1.91,4.03-3.79,6.14-5.63c2.41-2.12,4.89-4.19,7.49-6.19 c3.55-2.76,7.29-5.41,11.29-7.94c0.98-0.63,1.95-1.24,2.93-1.84c99.71-61.97,173.1-41.74,222.06,0c3.69,3.13,7.25,6.4,10.66,9.78 c2.08,2.01,4.09,4.09,6.04,6.19c0.22,0.22,0.42,0.45,0.63,0.69C422.01,109.38,423.34,110.85,424.64,112.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M428.576,102.386 l-335.466,1.53l5.074-7.603c2.44-3.656,6.545-5.852,10.94-5.852h303.555c3.981,0,7.749,1.803,10.245,4.905L428.576,102.386z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M266.69,239.359h-18.381c-18.861,0-34.152-15.29-34.152-34.152v-18.381c0-18.861,15.29-34.152,34.152-34.152h18.381 c18.862,0,34.152,15.29,34.152,34.152v18.381C300.842,224.069,285.551,239.359,266.69,239.359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M229.913,203.337v12.323c0,3.867,3.135,7.001,7.001,7.001h42.266c3.848,0,6.964-3.105,7.001-6.952 c0.053-5.544,0.349-12.372,0.349-12.372H229.913z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBFBF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M384.616,207.455H137.411c-2.61,0-4.953-1.602-5.901-4.034L93.38,105.563c-0.997-2.56,0.891-5.322,3.638-5.322H425.01 c2.747,0,4.636,2.762,3.638,5.322l-38.131,97.859C389.57,205.853,387.227,207.455,384.616,207.455z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "386.451,198.925 134.982,198.925 100.379,106.44 420.891,106.44  "
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 230.183,
    y: 207.321,
    style: {
      fill: "#263238"
    },
    width: 56.061,
    height: 3.838
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M349.717,194.954H172.141c-0.976,0-1.906-0.443-2.079-0.992l-25.258-80.248 c-0.283-0.9,0.505-1.633,1.761-1.633h228.727c1.257,0,2.044,0.733,1.761,1.633l-25.258,80.248 C351.623,194.511,350.692,194.954,349.717,194.954z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "349.062,193.135 172.796,193.135 151.331,122.624 370.527,122.624  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M198.096,140.13h-33.37c-0.824,0-1.365,0.445-1.209,0.991c0.156,0.545,0.945,0.986,1.764,0.986 h33.177c0.819,0,1.404-0.441,1.307-0.986C199.667,140.574,198.919,140.13,198.096,140.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M199.213,146.222h-28.38c-0.809,0-1.349,0.429-1.205,0.956 c0.143,0.526,0.911,0.951,1.716,0.951h28.219c0.805,0,1.381-0.425,1.287-0.951 C200.755,146.651,200.022,146.222,199.213,146.222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M200.292,152.102h-32.203c-0.795,0-1.322,0.414-1.176,0.923 c0.145,0.508,0.903,0.918,1.694,0.918h32.024c0.791,0,1.358-0.41,1.267-0.918 C201.806,152.516,201.087,152.102,200.292,152.102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M201.333,157.779h-18.915c-0.781,0-1.317,0.4-1.196,0.892c0.121,0.491,0.848,0.887,1.626,0.887 h18.811c0.777,0,1.336-0.396,1.249-0.887C202.82,158.179,202.115,157.779,201.333,157.779z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M202.34,163.264h-31.116c-0.768,0-1.281,0.387-1.145,0.862 c0.135,0.474,0.864,0.857,1.628,0.857h30.948c0.764,0,1.315-0.383,1.23-0.857C203.8,163.651,203.108,163.264,202.34,163.264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M203.313,168.568h-25.127c-0.756,0-1.268,0.374-1.145,0.834 c0.123,0.458,0.831,0.829,1.583,0.829h24.994c0.752,0,1.294-0.371,1.212-0.829 C204.747,168.942,204.068,168.568,203.313,168.568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M204.254,173.698h-24.717c-0.743,0-1.249,0.362-1.13,0.807 c0.119,0.444,0.814,0.802,1.553,0.802h24.588c0.739,0,1.274-0.359,1.195-0.802 C205.664,174.06,204.997,173.698,204.254,173.698z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M205.164,178.663h-26.967c-0.731,0-1.227,0.35-1.108,0.781c0.119,0.43,0.805,0.777,1.532,0.777 h26.829c0.727,0,1.255-0.347,1.178-0.777C206.551,179.014,205.896,178.663,205.164,178.663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M206.046,183.472h-17.419c-0.72,0-1.22,0.339-1.117,0.757 c0.102,0.416,0.766,0.753,1.482,0.753h17.331c0.716,0,1.236-0.337,1.162-0.753 C207.41,183.811,206.766,183.472,206.046,183.472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M196.937,133.813h-24.868c-0.839,0-1.4,0.461-1.253,1.028 c0.146,0.565,0.941,1.022,1.775,1.022h24.722c0.834,0,1.429-0.457,1.327-1.022 C198.539,134.274,197.776,133.813,196.937,133.813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M195.735,127.258h-34.624c-0.855,0-1.411,0.479-1.244,1.067 c0.167,0.587,0.991,1.061,1.841,1.061h34.416c0.85,0,1.454-0.474,1.349-1.061 C197.368,127.737,196.589,127.258,195.735,127.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M206.901,188.13h-28.693c-0.708,0-1.189,0.329-1.074,0.733 c0.115,0.403,0.779,0.729,1.484,0.729h28.551c0.705,0,1.218-0.326,1.146-0.729C208.243,188.459,207.609,188.13,206.901,188.13 z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "209.817,142.352 216.29,142.352 215.966,139.881 209.446,139.881  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "210.72,148.366 217.079,148.366 216.766,145.982 210.362,145.982  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "211.592,154.171 217.84,154.171 217.538,151.87 211.246,151.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "212.434,159.779 218.576,159.779 218.284,157.555 212.1,157.555  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "213.248,165.197 219.287,165.197 219.005,163.048 212.925,163.048  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "214.035,170.437 219.974,170.437 219.701,168.359 213.723,168.359  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "214.797,175.507 220.639,175.507 220.375,173.496 214.495,173.496  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "215.534,180.415 221.283,180.415 221.027,178.467 215.241,178.467  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "216.248,185.168 221.906,185.168 221.659,183.282 215.964,183.282  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "208.88,136.117 215.472,136.117 215.136,133.555 208.495,133.555  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "207.909,129.65 214.624,129.65 214.275,126.991 207.51,126.991  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "216.94,189.775 222.511,189.775 222.271,187.946 216.665,187.946  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M251.046,179.444c-0.014-0.431,0.567-0.781,1.299-0.781h95.819c0.731,0,1.222,0.35,1.096,0.781 c-0.125,0.429-0.816,0.777-1.544,0.777h-95.327C251.661,180.221,251.06,179.874,251.046,179.444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M349.126,175.307h-53.054c-0.739,0-1.299-0.359-1.25-0.802 c0.049-0.445,0.691-0.807,1.434-0.807h53.332c0.743,0,1.24,0.362,1.111,0.807 C350.569,174.948,349.865,175.307,349.126,175.307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M283.48,175.307h-16.505c-0.739,0-1.333-0.359-1.326-0.802 c0.007-0.445,0.615-0.807,1.358-0.807h16.591c0.743,0,1.318,0.362,1.283,0.807 C284.846,174.948,284.219,175.307,283.48,175.307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M317.924,170.23h-74.841c-0.751,0-1.384-0.371-1.412-0.829 c-0.028-0.46,0.561-0.834,1.317-0.834h75.239c0.755,0,1.298,0.374,1.212,0.834C319.354,169.859,318.675,170.23,317.924,170.23 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M227.435,168.568h5.335c0.755,0,1.4,0.374,1.439,0.834 c0.039,0.458-0.539,0.829-1.29,0.829h-5.306c-0.752,0-1.402-0.371-1.453-0.829 C226.108,168.941,226.679,168.568,227.435,168.568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M328.749,164.126c-0.101,0.474-0.802,0.857-1.566,0.857h-70.525 c-0.764,0-1.391-0.383-1.399-0.857c-0.008-0.475,0.607-0.862,1.376-0.862h70.907 C328.31,163.264,328.85,163.651,328.749,164.126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M226.869,163.264h20.015c0.768,0,1.406,0.387,1.425,0.862c0.019,0.474-0.586,0.857-1.35,0.857 h-19.907c-0.764,0-1.426-0.383-1.479-0.857C225.521,163.651,226.101,163.264,226.869,163.264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M226.284,157.778h76.931c0.781,0,1.361,0.4,1.295,0.892c-0.066,0.49-0.75,0.887-1.527,0.887 h-76.51c-0.777,0-1.451-0.396-1.506-0.887C224.913,158.178,225.503,157.778,226.284,157.778z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M276.232,153.942c-0.791,0-1.414-0.41-1.393-0.918c0.021-0.509,0.684-0.923,1.479-0.923h40.594 c0.795,0,1.368,0.414,1.279,0.923c-0.088,0.508-0.801,0.918-1.591,0.918H276.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M225.679,152.101h35.135c0.795,0,1.438,0.414,1.436,0.923 c-0.002,0.508-0.645,0.918-1.435,0.918h-34.939c-0.791,0-1.477-0.41-1.534-0.918 C224.285,152.515,224.883,152.101,225.679,152.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M356.925,148.129h-96.701c-0.805,0-1.46-0.425-1.463-0.951 c-0.003-0.527,0.65-0.956,1.459-0.956h97.252c0.809,0,1.34,0.429,1.187,0.956C358.506,147.704,357.73,148.129,356.925,148.129 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M358.653,142.106h-85.092c-0.819,0-1.469-0.441-1.451-0.986c0.018-0.547,0.7-0.991,1.524-0.991 h85.586c0.824,0,1.362,0.444,1.203,0.991C360.265,141.666,359.473,142.106,358.653,142.106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M360.445,135.863h-17.818c-0.834,0-1.405-0.457-1.274-1.022 c0.131-0.567,0.918-1.028,1.757-1.028h17.924c0.839,0,1.385,0.461,1.22,1.028 C362.089,135.406,361.279,135.863,360.445,135.863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M330.16,135.863h-65.43c-0.834,0-1.507-0.457-1.504-1.022c0.004-0.567,0.687-1.028,1.526-1.028 h65.817c0.839,0,1.425,0.461,1.31,1.028C331.764,135.406,330.994,135.863,330.16,135.863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M229.024,183.471h60.422c0.719,0,1.269,0.339,1.228,0.757 c-0.042,0.416-0.656,0.753-1.372,0.753h-60.117c-0.716,0-1.334-0.337-1.38-0.753 C227.759,183.811,228.304,183.471,229.024,183.471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M229.521,188.13h92.834c0.708,0,1.213,0.329,1.127,0.733c-0.086,0.403-0.727,0.729-1.432,0.729 h-92.374c-0.705,0-1.313-0.326-1.357-0.729C228.274,188.459,228.812,188.13,229.521,188.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M326.914,129.386h-47.261c-0.85,0-1.516-0.474-1.487-1.061c0.029-0.588,0.745-1.067,1.6-1.067 h47.546c0.855,0,1.457,0.478,1.344,1.067C328.543,128.912,327.763,129.386,326.914,129.386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M266.246,129.386h-42.99c-0.85,0-1.591-0.474-1.656-1.061 c-0.065-0.588,0.575-1.067,1.429-1.067h43.249c0.855,0,1.539,0.478,1.527,1.067 C267.794,128.912,267.096,129.386,266.246,129.386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M302.853,183.471c0.72,0,1.254,0.339,1.194,0.757 c-0.06,0.416-0.689,0.753-1.405,0.753h-4.67c-0.716,0-1.256-0.337-1.206-0.753c0.05-0.417,0.674-0.757,1.394-0.757H302.853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M245.537,179.444c0.022,0.429-0.55,0.777-1.278,0.777h-6.363 c-0.727,0-1.345-0.348-1.38-0.777c-0.035-0.431,0.53-0.781,1.261-0.781h6.395 C244.905,178.663,245.516,179.014,245.537,179.444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M322.293,158.67c-0.093,0.49-0.798,0.887-1.575,0.887h-7.438 c-0.777,0-1.345-0.396-1.267-0.887c0.078-0.492,0.774-0.892,1.556-0.892h7.479 C321.828,157.778,322.386,158.178,322.293,158.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M345.501,163.264c0.768,0,1.287,0.387,1.159,0.862 c-0.128,0.474-0.85,0.857-1.614,0.857h-5.929c-0.764,0-1.291-0.383-1.176-0.857c0.115-0.475,0.831-0.862,1.6-0.862H345.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M248.511,148.129c-0.805,0-1.475-0.425-1.497-0.951 c-0.022-0.527,0.617-0.956,1.426-0.956h6.312c0.809,0,1.471,0.429,1.479,0.956c0.007,0.526-0.639,0.951-1.444,0.951H248.511z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M162.572,117.338c0.489,1.638-0.456,2.95-2.105,2.95c-1.649,0-3.409-1.312-3.937-2.95 c-0.535-1.66,0.395-3.021,2.083-3.021C160.301,114.317,162.077,115.679,162.572,117.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M170.711,117.387c0.436,1.637-0.551,2.949-2.199,2.949s-3.366-1.312-3.842-2.949 c-0.482-1.659,0.492-3.02,2.18-3.02C168.538,114.367,170.269,115.728,170.711,117.387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M178.944,117.338c0.383,1.638-0.647,2.95-2.296,2.95c-1.649,0-3.324-1.312-3.746-2.95 c-0.428-1.66,0.59-3.021,2.279-3.021C176.869,114.317,178.556,115.679,178.944,117.338z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF"
    },
    points: "100.379,106.44 127.328,178.467 159.837,106.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF"
    },
    points: "145.847,198.925 199.776,106.44 256.231,106.44 176.861,198.925  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF"
    },
    points: "280.559,105.985 196.503,198.925 209.446,198.925 296.519,106.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF"
    },
    points: "297.156,198.925 389.54,106.44 402.576,106.44 307.328,198.925  "
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Code_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M171.902,239.067h-21.096c-2.739,0-4.959,2.22-4.959,4.959v10.264c0,2.739,2.22,4.959,4.959,4.959h5.514l4.178,9.47l5.89-9.47 h5.514c2.739,0,4.959-2.22,4.959-4.959v-10.264C176.861,241.287,174.641,239.067,171.902,239.067z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M158.422,244.938c0-0.54,0.437-0.963,1.028-0.963c0.591,0,1.028,0.398,1.028,0.925 c0,0.566-0.424,1.003-1.028,1.003C158.859,245.901,158.422,245.477,158.422,244.938z M158.641,247.032h1.606v6.861h-1.606 V247.032z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M164.124,246.672v0.411h1.889v1.285h-1.837v5.524h-1.606v-5.524h-1.131v-1.285h1.131v-0.436 c0-1.439,0.861-2.377,2.454-2.377c0.552,0,1.092,0.116,1.452,0.373l-0.45,1.207c-0.244-0.167-0.552-0.282-0.887-0.282 C164.471,245.567,164.124,245.94,164.124,246.672z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M236.118,240.504h-21.096c-2.739,0-4.959,2.22-4.959,4.959v10.264c0,2.739,2.22,4.959,4.959,4.959h5.514l4.178,9.47l5.89-9.47 h5.514c2.739,0,4.959-2.22,4.959-4.959v-10.264C241.077,242.724,238.857,240.504,236.118,240.504z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M219.456,252.414h-5.383c0.193,1.002,1.028,1.645,2.223,1.645c0.771,0,1.374-0.244,1.863-0.746 l0.861,0.99c-0.617,0.731-1.58,1.117-2.762,1.117c-2.3,0-3.79-1.478-3.79-3.521c0-2.042,1.503-3.507,3.546-3.507 c2.004,0,3.469,1.4,3.469,3.546C219.481,252.066,219.469,252.26,219.456,252.414z M214.06,251.348h3.893 c-0.128-0.99-0.886-1.671-1.94-1.671C214.972,249.677,214.214,250.345,214.06,251.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M221.019,245.797h1.606v9.533h-1.606V245.797z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M223.946,254.649l0.617-1.221c0.604,0.398,1.529,0.681,2.39,0.681 c1.015,0,1.439-0.282,1.439-0.758c0-1.311-4.24-0.077-4.24-2.814c0-1.297,1.169-2.145,3.019-2.145 c0.912,0,1.953,0.219,2.57,0.591l-0.617,1.22c-0.655-0.385-1.31-0.514-1.965-0.514c-0.977,0-1.439,0.321-1.439,0.771 c0,1.388,4.24,0.154,4.24,2.839c0,1.285-1.182,2.12-3.109,2.12C225.706,255.42,224.563,255.086,223.946,254.649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M237.767,252.414h-5.383c0.193,1.002,1.028,1.645,2.223,1.645c0.771,0,1.374-0.244,1.863-0.746 l0.861,0.99c-0.617,0.731-1.58,1.117-2.762,1.117c-2.3,0-3.79-1.478-3.79-3.521c0-2.042,1.503-3.507,3.546-3.507 c2.004,0,3.469,1.4,3.469,3.546C237.792,252.066,237.779,252.26,237.767,252.414z M232.371,251.348h3.893 c-0.128-0.99-0.886-1.671-1.94-1.671C233.283,249.677,232.524,250.345,232.371,251.348z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M298.378,239.895h-21.096c-2.739,0-4.959,2.22-4.959,4.959v10.264c0,2.739,2.22,4.959,4.959,4.959h5.514l4.178,9.47l5.89-9.47 h5.514c2.739,0,4.959-2.22,4.959-4.959v-10.264C303.337,242.115,301.117,239.895,298.378,239.895z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M282.12,247.501v0.411h1.889v1.285h-1.837v5.524h-1.607v-5.524h-1.13v-1.285h1.13v-0.436 c0-1.439,0.861-2.377,2.454-2.377c0.553,0,1.093,0.116,1.452,0.373l-0.45,1.207c-0.243-0.167-0.552-0.282-0.886-0.282 C282.468,246.396,282.12,246.769,282.12,247.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M284.418,251.291c0-2.055,1.542-3.507,3.648-3.507c2.133,0,3.662,1.452,3.662,3.507 c0,2.056-1.529,3.52-3.662,3.52C285.96,254.811,284.418,253.347,284.418,251.291z M290.109,251.291 c0-1.31-0.873-2.146-2.043-2.146c-1.156,0-2.029,0.836-2.029,2.146c0,1.311,0.873,2.145,2.029,2.145 C289.236,253.436,290.109,252.602,290.109,251.291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M297.234,247.784v1.529c-0.142-0.025-0.257-0.038-0.372-0.038c-1.221,0-1.992,0.719-1.992,2.12 v3.327h-1.605v-6.861h1.528v1.003C295.256,248.144,296.091,247.784,297.234,247.784z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M359.738,239.067h-21.096c-2.739,0-4.959,2.22-4.959,4.959v10.264c0,2.739,2.22,4.959,4.959,4.959h5.514l4.178,9.47l5.89-9.47 h5.514c2.739,0,4.959-2.22,4.959-4.959v-10.264C364.697,241.287,362.477,239.067,359.738,239.067z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M346.449,246.694h5.923v1.285h-5.923V246.694z M346.449,249.803h5.923v1.285h-5.923V249.803z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M204.058,227.188h-21.096c-2.739,0-4.959,2.22-4.959,4.959v10.264c0,2.739,2.22,4.959,4.959,4.959h5.514l4.178,9.47l5.89-9.47 h5.514c2.739,0,4.959-2.22,4.959-4.959v-10.264C209.017,229.408,206.797,227.188,204.058,227.188z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M188.547,231.454h3.071v1.285h-1.465v9.456h1.465v1.285h-3.071V231.454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M195.596,243.48v-1.285h1.452v-9.456h-1.452v-1.285h3.058v12.026H195.596z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M266.779,226.139h-21.096c-2.739,0-4.959,2.22-4.959,4.959v10.264c0,2.739,2.22,4.959,4.959,4.959h5.514l4.178,9.47l5.89-9.47 h5.514c2.739,0,4.959-2.22,4.959-4.959v-10.264C271.738,228.359,269.518,226.139,266.779,226.139z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M251.938,236.375c0.514,0.167,0.758,0.514,0.758,1.311v2.441c0,0.617,0.309,0.976,0.951,0.976 h0.27v1.285h-0.643c-1.451,0-2.184-0.732-2.184-2.094v-2.647c0-0.424-0.219-0.617-0.578-0.617h-0.424v-1.311h0.424 c0.359,0,0.578-0.192,0.578-0.617v-2.646c0-1.362,0.732-2.094,2.184-2.094h0.643v1.285h-0.27c-0.643,0-0.951,0.36-0.951,0.977 v2.441C252.695,235.861,252.451,236.208,251.938,236.375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M261.735,235.72v1.311h-0.437c-0.347,0-0.565,0.193-0.565,0.617v2.647 c0,1.362-0.745,2.094-2.197,2.094h-0.642v-1.285h0.27c0.655,0,0.964-0.359,0.964-0.976v-2.441c0-0.796,0.23-1.143,0.745-1.311 c-0.515-0.167-0.745-0.514-0.745-1.311v-2.441c0-0.617-0.309-0.977-0.964-0.977h-0.27v-1.285h0.642 c1.452,0,2.197,0.732,2.197,2.094v2.646c0,0.424,0.219,0.617,0.565,0.617H261.735z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M328.835,224.059h-21.096c-2.739,0-4.959,2.22-4.959,4.959v10.264c0,2.739,2.22,4.959,4.959,4.959h5.514l4.178,9.47l5.89-9.47 h5.514c2.739,0,4.959-2.22,4.959-4.959v-10.264C333.794,226.279,331.574,224.059,328.835,224.059z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M317.448,231.656c0-0.642,0.476-1.066,1.054-1.066c0.578,0,1.054,0.424,1.054,1.066 c0,0.617-0.476,1.066-1.054,1.066C317.924,232.722,317.448,232.273,317.448,231.656z M319.556,236.551 c0,0.283-0.065,0.514-0.296,1.105l-0.655,1.811h-1.04l0.514-1.966c-0.359-0.154-0.604-0.488-0.604-0.951 c0-0.642,0.449-1.066,1.04-1.066C319.119,235.484,319.556,235.921,319.556,236.551z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M246.356,403.499h21.096c2.739,0,4.959-2.22,4.959-4.959v-10.264c0-2.739-2.22-4.959-4.959-4.959h-5.514l-1.61-9.47 l-8.458,9.47h-5.514c-2.739,0-4.959,2.22-4.959,4.959v10.264C241.397,401.279,243.618,403.499,246.356,403.499z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M253.772,391.299l-4.432,1.657l4.432,1.657v1.337l-5.923-2.3v-1.388l5.923-2.3V391.299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M258.445,386.635h1.439l-4.239,12.104h-1.439L258.445,386.635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M266.112,392.263v1.388l-5.923,2.3v-1.337l4.433-1.657l-4.433-1.657v-1.336L266.112,392.263z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M112.237,328.754h21.096c2.739,0,4.959-2.22,4.959-4.959v-10.264c0-2.739-2.22-4.959-4.959-4.959h-5.514l1.201-9.47 l-11.27,9.47h-5.514c-2.739,0-4.959,2.22-4.959,4.959v10.264C107.278,326.534,109.498,328.754,112.237,328.754z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M118.491,322.245c0-0.553,0.437-0.989,1.041-0.989c0.591,0,1.015,0.437,1.015,0.989 c0,0.553-0.424,1.002-1.015,1.002C118.928,323.247,118.491,322.798,118.491,322.245z M118.581,314.164h1.901l-0.321,6.013 h-1.272L118.581,314.164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M122.138,316.464h5.923v1.284h-5.923V316.464z M122.138,319.572h5.923v1.285h-5.923V319.572z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Mouse"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    d: "M450.033,317.117c0,4.12-0.342,8.111-0.974,11.867c-2.9,17.303-11.995,29.929-22.76,29.929 c-0.963,0-1.926-0.107-2.857-0.3c-11.749-2.493-20.866-20.117-20.866-41.497c0-23.081,10.625-31.245,23.723-31.245 C439.407,285.872,450.033,294.036,450.033,317.117z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_4_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000030454967693796625300000014648086092702892938_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_4_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#XMLID_00000030454967693796625300000014648086092702892938_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M441.432,317.381c0.883,12.377-1.246,24.82-4.812,36.705 c8.939-7.335,13.052-18.875,16.767-29.825c2.698-7.952,5.432-16.15,4.946-24.533c-0.487-8.383-4.979-17.103-12.845-20.042 c-3.844-1.436-8.318-1.33-12.123,0.196c-6.592,2.644-2.983,4.792-0.216,9.525 C438.102,297.883,440.736,307.625,441.432,317.381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M441.432,317.381c0.883,12.377-1.246,24.82-4.812,36.705 c8.939-7.335,13.052-18.875,16.767-29.825c2.698-7.952,5.432-16.15,4.946-24.533c-0.487-8.383-4.979-17.103-12.845-20.042 c-3.844-1.436-8.318-1.33-12.123,0.196c-6.592,2.644-2.983,4.792-0.216,9.525 C438.102,297.883,440.736,307.625,441.432,317.381z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_4_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M439.047,338.353c-1.585,5.326-4.214,10.337-7.782,14.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M439.802,335.445c-0.126,0.565-0.263,1.127-0.411,1.686"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M439.741,317.063c1.265,5.324,1.389,10.89,0.472,16.282"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M402.574,317.119c0,0,26.969-10.663,47.453,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M426.301,285.872c0,0,2.701,10.002,3.013,26.264"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBFBF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M430.065,298.037c0.346,3.108-0.192,5.757-1.202,5.917c-1.01,0.16-2.11-2.23-2.457-5.339c-0.346-3.108,0.192-5.758,1.202-5.917 C428.619,292.539,429.718,294.929,430.065,298.037z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M415.66,366.91h-31.62c-3.94,0-7.18-2.92-7.69-6.71 c-0.07-0.34-0.09-0.7-0.09-1.07v-74.59c0-0.36,0.02-0.72,0.09-1.08c0.51-3.79,3.75-6.7,7.69-6.7h89.72c1.36,0,2.63,0.35,3.73,0.96 "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg102593404401278);
export default __webpack_public_path__ + "static/media/10259340_4401278.7d2f7c8831b7371d87faa805416f51ef.svg";
export { ForwardRef as ReactComponent };